import { BaseAPI, JSONApiResponse, RequiredError, TextApiResponse, VoidApiResponse, BlobApiResponse } from '../runtime.js';
import { ApiActivityFromJSONTyped } from '../models/ApiActivity.js';
import '../models/ApiActivityType.js';
import { ApiAddBusinesPartnerRequestFromJSONTyped } from '../models/ApiAddBusinesPartnerRequest.js';
import { ApiAddItemRequestFromJSONTyped } from '../models/ApiAddItemRequest.js';
import '../models/ApiAdditionalInfoType.js';
import { ApiAffiliateRequestFromJSONTyped } from '../models/ApiAffiliateRequest.js';
import { ApiAffiliateResponseFromJSON } from '../models/ApiAffiliateResponse.js';
import { ApiAgencyFromJSON } from '../models/ApiAgency.js';
import { ApiAgencyUserRequestFromJSONTyped } from '../models/ApiAgencyUserRequest.js';
import '../models/ApiAirportType.js';
import { ApiApiBaseResponseFromJSON } from '../models/ApiApiBaseResponse.js';
import { ApiApplyPaxRoomAssignmentRequestFromJSONTyped } from '../models/ApiApplyPaxRoomAssignmentRequest.js';
import { ApiApplyPaxRoomAssignmentResponseFromJSON } from '../models/ApiApplyPaxRoomAssignmentResponse.js';
import { ApiAttractionAvailabilityInfoFromJSON } from '../models/ApiAttractionAvailabilityInfo.js';
import { ApiAuthenticateRequestFromJSONTyped } from '../models/ApiAuthenticateRequest.js';
import { ApiAuthenticateResponseFromJSON } from '../models/ApiAuthenticateResponse.js';
import '../models/ApiBaggageType.js';
import '../models/ApiBaggageUnitType.js';
import '../models/ApiBaseDataSource.js';
import { ApiBaseModelFromJSONTyped, ApiBaseModelFromJSON } from '../models/ApiBaseModel.js';
import { ApiBlockchainWalletFromJSONTyped } from '../models/ApiBlockchainWallet.js';
import { ApiBookingFromJSON } from '../models/ApiBooking.js';
import '../models/ApiBookingAction.js';
import { ApiBookingCancelRequestFromJSONTyped } from '../models/ApiBookingCancelRequest.js';
import { ApiBookingLoginRequestFromJSONTyped } from '../models/ApiBookingLoginRequest.js';
import { ApiBookingPaneFromJSON } from '../models/ApiBookingPane.js';
import { ApiBookingSearchFromJSONTyped } from '../models/ApiBookingSearch.js';
import '../models/ApiBookingState.js';
import '../models/ApiCabinClass.js';
import '../models/ApiCamperFeatureType.js';
import { ApiCancelRequestFromJSONTyped } from '../models/ApiCancelRequest.js';
import { ApiChangeComponentsRequestFromJSONTyped } from '../models/ApiChangeComponentsRequest.js';
import { ApiChangePasswordRequestFromJSONTyped } from '../models/ApiChangePasswordRequest.js';
import { ApiChangeServiceDateRequestFromJSONTyped } from '../models/ApiChangeServiceDateRequest.js';
import '../models/ApiClientType.js';
import { ApiComponentListOptionResponseFromJSON } from '../models/ApiComponentListOptionResponse.js';
import '../models/ApiComponentPriceType.js';
import '../models/ApiComponentType.js';
import { ApiConfigurationDataRequestFromJSONTyped } from '../models/ApiConfigurationDataRequest.js';
import { ApiConfigurationDataResponseFromJSON } from '../models/ApiConfigurationDataResponse.js';
import '../models/ApiConfigurationDataType.js';
import '../models/ApiDebitType.js';
import { ApiDeleteTokenForBookingRequestFromJSONTyped } from '../models/ApiDeleteTokenForBookingRequest.js';
import { ApiDescriptionDataFromJSON } from '../models/ApiDescriptionData.js';
import '../models/ApiDirection.js';
import '../models/ApiDistanceUnit.js';
import '../models/ApiDocumentSubType.js';
import '../models/ApiDocumentType.js';
import '../models/ApiDurationType.js';
import { ApiEditBusinesPartnerRequestFromJSONTyped } from '../models/ApiEditBusinesPartnerRequest.js';
import { ApiFetchAgencyRequestFromJSONTyped } from '../models/ApiFetchAgencyRequest.js';
import '../models/ApiFilterCategory.js';
import '../models/ApiFilterType.js';
import { ApiFlightDepartureRequestFromJSONTyped } from '../models/ApiFlightDepartureRequest.js';
import { ApiFlightDepartureResponseFromJSON } from '../models/ApiFlightDepartureResponse.js';
import { ApiFlightTravelStartDateRequestFromJSONTyped } from '../models/ApiFlightTravelStartDateRequest.js';
import { ApiFlightTravelStartDateResponseFromJSON } from '../models/ApiFlightTravelStartDateResponse.js';
import '../models/ApiFuelType.js';
import '../models/ApiGender.js';
import { ApiGetAdditionalInsuranceListRequestFromJSONTyped } from '../models/ApiGetAdditionalInsuranceListRequest.js';
import { ApiGetAdditionalInsuranceListResponseFromJSON } from '../models/ApiGetAdditionalInsuranceListResponse.js';
import { ApiGetAgencyCreditLimitResponseFromJSON } from '../models/ApiGetAgencyCreditLimitResponse.js';
import { ApiGetAttractionAvailabilityRequestFromJSONTyped } from '../models/ApiGetAttractionAvailabilityRequest.js';
import { ApiGetBestPricePackageAvailabilityRequestFromJSONTyped } from '../models/ApiGetBestPricePackageAvailabilityRequest.js';
import { ApiGetBestPricePackageAvailabilityResponseFromJSON } from '../models/ApiGetBestPricePackageAvailabilityResponse.js';
import { ApiGetBestPricePackagesResponseFromJSON } from '../models/ApiGetBestPricePackagesResponse.js';
import { ApiGetBusinessPartnerRequestFromJSONTyped } from '../models/ApiGetBusinessPartnerRequest.js';
import { ApiGetBusinessPartnerResponseFromJSON } from '../models/ApiGetBusinessPartnerResponse.js';
import { ApiGetCamperDetailsRequestFromJSONTyped } from '../models/ApiGetCamperDetailsRequest.js';
import { ApiGetCamperDetailsResponseFromJSON } from '../models/ApiGetCamperDetailsResponse.js';
import { ApiGetCamperListRequestFromJSONTyped } from '../models/ApiGetCamperListRequest.js';
import { ApiGetCamperListResponseFromJSON } from '../models/ApiGetCamperListResponse.js';
import { ApiGetCamperTermsAndConditionsRequestFromJSONTyped } from '../models/ApiGetCamperTermsAndConditionsRequest.js';
import { ApiGetCamperTermsAndConditionsResponseFromJSON } from '../models/ApiGetCamperTermsAndConditionsResponse.js';
import { ApiGetCountriesListResponseFromJSON } from '../models/ApiGetCountriesListResponse.js';
import { ApiGetDescriptionDataRequestFromJSONTyped } from '../models/ApiGetDescriptionDataRequest.js';
import { ApiGetExtraServiceListRequestFromJSONTyped } from '../models/ApiGetExtraServiceListRequest.js';
import { ApiGetExtraServiceListResponseFromJSON } from '../models/ApiGetExtraServiceListResponse.js';
import { ApiGetExtraServiceRequestFromJSONTyped } from '../models/ApiGetExtraServiceRequest.js';
import { ApiGetExtraServiceResponseFromJSON } from '../models/ApiGetExtraServiceResponse.js';
import { ApiGetFlightListRequestFromJSONTyped } from '../models/ApiGetFlightListRequest.js';
import { ApiGetFlightListResponseFromJSON } from '../models/ApiGetFlightListResponse.js';
import { ApiGetFlightTripBookingResponseFromJSON } from '../models/ApiGetFlightTripBookingResponse.js';
import { ApiGetFlightTripPackageRequestFromJSONTyped } from '../models/ApiGetFlightTripPackageRequest.js';
import { ApiGetFlightTripUpdateBookingRequestFromJSONTyped } from '../models/ApiGetFlightTripUpdateBookingRequest.js';
import { ApiGetGeoUnitRulesRequestFromJSONTyped } from '../models/ApiGetGeoUnitRulesRequest.js';
import { ApiGetGeoUnitRulesResponseFromJSON } from '../models/ApiGetGeoUnitRulesResponse.js';
import { ApiGetGeoUnitsRequestFromJSONTyped } from '../models/ApiGetGeoUnitsRequest.js';
import { ApiGetGeoUnitsResponseFromJSON } from '../models/ApiGetGeoUnitsResponse.js';
import { ApiGetGroupedHotelPricesRequestFromJSONTyped } from '../models/ApiGetGroupedHotelPricesRequest.js';
import { ApiGetGroupedHotelPricesResponseFromJSON } from '../models/ApiGetGroupedHotelPricesResponse.js';
import { ApiGetHotelCharacteristicsResponseFromJSON } from '../models/ApiGetHotelCharacteristicsResponse.js';
import { ApiGetHotelDetailsRequestFromJSONTyped } from '../models/ApiGetHotelDetailsRequest.js';
import { ApiGetHotelDetailsResponseFromJSON } from '../models/ApiGetHotelDetailsResponse.js';
import { ApiGetHotelListRequestFromJSONTyped } from '../models/ApiGetHotelListRequest.js';
import { ApiGetHotelListResponseFromJSON } from '../models/ApiGetHotelListResponse.js';
import { ApiGetHotelPriceCurveRequestFromJSONTyped } from '../models/ApiGetHotelPriceCurveRequest.js';
import { ApiGetHotelPriceCurveResponseFromJSON } from '../models/ApiGetHotelPriceCurveResponse.js';
import { ApiGetHotelsByTargetRequestFromJSONTyped } from '../models/ApiGetHotelsByTargetRequest.js';
import { ApiGetHotelsByTargetResponseFromJSON } from '../models/ApiGetHotelsByTargetResponse.js';
import { ApiGetInsuranceDetailsRequestFromJSONTyped } from '../models/ApiGetInsuranceDetailsRequest.js';
import { ApiGetInsuranceDetailsResponseFromJSON } from '../models/ApiGetInsuranceDetailsResponse.js';
import { ApiGetInsuranceListRequestFromJSONTyped } from '../models/ApiGetInsuranceListRequest.js';
import { ApiGetInsuranceListResponseFromJSON } from '../models/ApiGetInsuranceListResponse.js';
import { ApiGetItemTripListRequestFromJSONTyped } from '../models/ApiGetItemTripListRequest.js';
import { ApiGetItemTripListResponseFromJSON } from '../models/ApiGetItemTripListResponse.js';
import { ApiGetItemTripRequestFromJSONTyped } from '../models/ApiGetItemTripRequest.js';
import { ApiGetItemTripResponseFromJSON } from '../models/ApiGetItemTripResponse.js';
import { ApiGetLocationRelationsResponseFromJSON } from '../models/ApiGetLocationRelationsResponse.js';
import { ApiGetOfferListRequestFromJSONTyped } from '../models/ApiGetOfferListRequest.js';
import { ApiGetOfferListResponseFromJSON } from '../models/ApiGetOfferListResponse.js';
import { ApiGetPackageCartStartOptionsFromJSONTyped } from '../models/ApiGetPackageCartStartOptions.js';
import { ApiGetPackageComponentsRQFromJSONTyped } from '../models/ApiGetPackageComponentsRQ.js';
import { ApiGetPackageComponentsRSFromJSON } from '../models/ApiGetPackageComponentsRS.js';
import { ApiGetPackageDefinitionByCodesRequestFromJSONTyped } from '../models/ApiGetPackageDefinitionByCodesRequest.js';
import { ApiGetPackagesRequestFromJSONTyped } from '../models/ApiGetPackagesRequest.js';
import { ApiGetPackagesResponseFromJSON } from '../models/ApiGetPackagesResponse.js';
import { ApiGetPasswordComplexityResponseFromJSON } from '../models/ApiGetPasswordComplexityResponse.js';
import { ApiGetPaxRoomAssignmentRequestFromJSONTyped } from '../models/ApiGetPaxRoomAssignmentRequest.js';
import { ApiGetPaxRoomAssignmentResponseFromJSON } from '../models/ApiGetPaxRoomAssignmentResponse.js';
import { ApiGetPaymentOptionsResponseFromJSON } from '../models/ApiGetPaymentOptionsResponse.js';
import { ApiGetRecommendationsRequestFromJSONTyped } from '../models/ApiGetRecommendationsRequest.js';
import { ApiGetRecommendationsResponseFromJSON } from '../models/ApiGetRecommendationsResponse.js';
import { ApiGetRentalCarDetailsRequestFromJSONTyped } from '../models/ApiGetRentalCarDetailsRequest.js';
import { ApiGetRentalCarDetailsResponseFromJSON } from '../models/ApiGetRentalCarDetailsResponse.js';
import { ApiGetRentalCarListRequestFromJSONTyped } from '../models/ApiGetRentalCarListRequest.js';
import { ApiGetRentalCarListResponseFromJSON } from '../models/ApiGetRentalCarListResponse.js';
import { ApiGetRentalCarStationsRequestFromJSONTyped } from '../models/ApiGetRentalCarStationsRequest.js';
import { ApiGetRentalCarStationsResponseFromJSON } from '../models/ApiGetRentalCarStationsResponse.js';
import { ApiGetRentalCarTermsAndConditionsRequestFromJSONTyped } from '../models/ApiGetRentalCarTermsAndConditionsRequest.js';
import { ApiGetRentalCarTermsAndConditionsResponseFromJSON } from '../models/ApiGetRentalCarTermsAndConditionsResponse.js';
import { ApiGetSeatMapRequestFromJSONTyped } from '../models/ApiGetSeatMapRequest.js';
import { ApiGetSeatMapResponseFromJSON } from '../models/ApiGetSeatMapResponse.js';
import { ApiGetSeatMapsRequestFromJSONTyped } from '../models/ApiGetSeatMapsRequest.js';
import { ApiGetSeatMapsResponseFromJSON } from '../models/ApiGetSeatMapsResponse.js';
import { ApiGetTransferDetailsRequestFromJSONTyped } from '../models/ApiGetTransferDetailsRequest.js';
import { ApiGetTransferDetailsResponseFromJSON } from '../models/ApiGetTransferDetailsResponse.js';
import { ApiGetTransferListRequestFromJSONTyped } from '../models/ApiGetTransferListRequest.js';
import { ApiGetTransferListResponseFromJSON } from '../models/ApiGetTransferListResponse.js';
import { ApiGetVoucherValueRequestFromJSONTyped } from '../models/ApiGetVoucherValueRequest.js';
import { ApiGetVoucherValueResponseFromJSON } from '../models/ApiGetVoucherValueResponse.js';
import { ApiGroupRequestFromJSONTyped } from '../models/ApiGroupRequest.js';
import '../models/ApiImageType.js';
import '../models/ApiInventory.js';
import '../models/ApiItemType.js';
import { ApiListOptionsFromJSONTyped } from '../models/ApiListOptions.js';
import { ApiMasterDataResponseFromJSON } from '../models/ApiMasterDataResponse.js';
import { ApiNewsletterSubscriptionRequestFromJSONTyped } from '../models/ApiNewsletterSubscriptionRequest.js';
import { ApiNoteFromJSONTyped } from '../models/ApiNote.js';
import '../models/ApiNoteOriginType.js';
import '../models/ApiNoteType.js';
import { ApiOverlaySeatMapRequestFromJSONTyped } from '../models/ApiOverlaySeatMapRequest.js';
import { ApiOverlaySeatMapResponseFromJSON } from '../models/ApiOverlaySeatMapResponse.js';
import { ApiPackageCartFromJSON } from '../models/ApiPackageCart.js';
import { ApiPackageModelFromJSON } from '../models/ApiPackageModel.js';
import { ApiPackageModelDefinitionFromJSON } from '../models/ApiPackageModelDefinition.js';
import '../models/ApiPackagePriceComponentType.js';
import '../models/ApiPaymentDataType.js';
import '../models/ApiPaymentOption.js';
import '../models/ApiPaymentState.js';
import { ApiPreparePaymentRequestFromJSONTyped } from '../models/ApiPreparePaymentRequest.js';
import { ApiPriceFromJSON } from '../models/ApiPrice.js';
import '../models/ApiPriceModifierType.js';
import '../models/ApiPriceType.js';
import { ApiProductWithReviewsFromJSON } from '../models/ApiProductWithReviews.js';
import { ApiProductsCacheRequestFromJSONTyped } from '../models/ApiProductsCacheRequest.js';
import { ApiProductsCacheResponseFromJSON } from '../models/ApiProductsCacheResponse.js';
import { ApiProductsSearchResponseFromJSON } from '../models/ApiProductsSearchResponse.js';
import '../models/ApiRecommendationServiceType.js';
import '../models/ApiRelatedServiceRelationType.js';
import { ApiRemovePackageItemsRequestFromJSONTyped } from '../models/ApiRemovePackageItemsRequest.js';
import { ApiRentalCarOfficeFromJSONTyped } from '../models/ApiRentalCarOffice.js';
import { ApiRentalCarOfficesRequestFromJSONTyped } from '../models/ApiRentalCarOfficesRequest.js';
import { ApiRentalCarOfficesResponseFromJSON } from '../models/ApiRentalCarOfficesResponse.js';
import { ApiResetAgencyPasswordRequestFromJSONTyped } from '../models/ApiResetAgencyPasswordRequest.js';
import '../models/ApiRole.js';
import '../models/ApiRowCharacteristics.js';
import { ApiSearchGeoUnitsRequestFromJSONTyped } from '../models/ApiSearchGeoUnitsRequest.js';
import { ApiSearchGeoUnitsResponseFromJSON } from '../models/ApiSearchGeoUnitsResponse.js';
import { ApiSearchProductDataByCodeRequestFromJSONTyped } from '../models/ApiSearchProductDataByCodeRequest.js';
import { ApiSearchProductDataByCodeResponseFromJSON } from '../models/ApiSearchProductDataByCodeResponse.js';
import { ApiSearchProductDataRequestFromJSONTyped } from '../models/ApiSearchProductDataRequest.js';
import { ApiSearchProductDataResponseFromJSON } from '../models/ApiSearchProductDataResponse.js';
import { ApiSearchRentalCarStationsRequestFromJSONTyped } from '../models/ApiSearchRentalCarStationsRequest.js';
import { ApiSearchRentalCarStationsResponseFromJSON } from '../models/ApiSearchRentalCarStationsResponse.js';
import { ApiSeasonFromJSON } from '../models/ApiSeason.js';
import '../models/ApiSeatCharacteristics.js';
import { ApiSelectPackageItemsRequestFromJSONTyped } from '../models/ApiSelectPackageItemsRequest.js';
import { ApiSendBookingListRequestFromJSONTyped } from '../models/ApiSendBookingListRequest.js';
import { ApiSendEmailMessageRequestFromJSONTyped } from '../models/ApiSendEmailMessageRequest.js';
import '../models/ApiServiceSelectionType.js';
import { ApiSignupRequestFromJSONTyped } from '../models/ApiSignupRequest.js';
import '../models/ApiSortDirection.js';
import '../models/ApiSortOption.js';
import { ApiSpecialRequestFromJSON } from '../models/ApiSpecialRequest.js';
import '../models/ApiSpecialRequestGroup.js';
import { ApiSpecialRequestsRestrictionFromJSON } from '../models/ApiSpecialRequestsRestriction.js';
import { ApiStaticContentRequestFromJSONTyped } from '../models/ApiStaticContentRequest.js';
import { ApiStaticContentResponseFromJSON } from '../models/ApiStaticContentResponse.js';
import '../models/ApiStaticContentType.js';
import { ApiSubmitDiscountRequestFromJSONTyped } from '../models/ApiSubmitDiscountRequest.js';
import { ApiTaxCodeValidationRequestFromJSONTyped } from '../models/ApiTaxCodeValidationRequest.js';
import { ApiTaxCodeValidationResponseFromJSON } from '../models/ApiTaxCodeValidationResponse.js';
import '../models/ApiTaxDisplay.js';
import { ApiTextSearchRequestFromJSONTyped } from '../models/ApiTextSearchRequest.js';
import { ApiTextSearchResponseFromJSON } from '../models/ApiTextSearchResponse.js';
import { ApiThemeResponseFromJSON } from '../models/ApiThemeResponse.js';
import { ApiTicketResponseFromJSON } from '../models/ApiTicketResponse.js';
import '../models/ApiTransmissionType.js';
import { ApiTravelAdviceResponseFromJSON } from '../models/ApiTravelAdviceResponse.js';
import '../models/ApiTravelStatusEnum.js';
import { ApiTravelerFromJSONTyped, ApiTravelerFromJSON } from '../models/ApiTraveler.js';
import '../models/ApiTravelerType.js';
import { ApiUpdateAffiliateRequestFromJSONTyped } from '../models/ApiUpdateAffiliateRequest.js';
import { ApiUpdateBookingItemSpecialRequestFromJSONTyped } from '../models/ApiUpdateBookingItemSpecialRequest.js';
import { ApiUpdateCaptureDataRequestFromJSONTyped } from '../models/ApiUpdateCaptureDataRequest.js';
import { ApiUpdateCustomerRequestFromJSONTyped } from '../models/ApiUpdateCustomerRequest.js';
import { ApiUpdateNotesRequestFromJSONTyped } from '../models/ApiUpdateNotesRequest.js';
import { ApiUpdateServiceNotesRequestFromJSONTyped } from '../models/ApiUpdateServiceNotesRequest.js';
import { ApiUpdateTravelerAssignmentRequestFromJSONTyped } from '../models/ApiUpdateTravelerAssignmentRequest.js';
import { ApiVoucherFromJSON } from '../models/ApiVoucher.js';
import { ApiVoucherBookingRequestFromJSONTyped } from '../models/ApiVoucherBookingRequest.js';
import '../models/ApiVoucherDeliveryType.js';
import { ApiVouchersResponseFromJSON } from '../models/ApiVouchersResponse.js';
import '../models/ApiWalletType.js';
import { ApiWebsiteDestinationSearchResponseFromJSON } from '../models/ApiWebsiteDestinationSearchResponse.js';
import { ApiWebsiteFaqSearchResponseFromJSON } from '../models/ApiWebsiteFaqSearchResponse.js';
import { ApiWebsiteOtherPagesSearchResponseFromJSON } from '../models/ApiWebsiteOtherPagesSearchResponse.js';
import { ApiWebsiteProductSearchResponseFromJSON } from '../models/ApiWebsiteProductSearchResponse.js';
import { ApiWebsiteQuickSearchResponseFromJSON } from '../models/ApiWebsiteQuickSearchResponse.js';
import { ApiWorkflowStepRequestFromJSONTyped } from '../models/ApiWorkflowStepRequest.js';
import { ApiWorkflowStepResponseFromJSON } from '../models/ApiWorkflowStepResponse.js';

/* tslint:disable */
/**
 * no description
 */
class DefaultApi extends BaseAPI {
    /**
     * registrate a user
     */
    async addAgencyUserRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/businesspartner/addAgencyUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiAgencyUserRequestFromJSONTyped(requestParameters.apiAgencyUserRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiMasterDataResponseFromJSON(jsonValue));
    }
    /**
     * registrate a user
     */
    async addAgencyUser(apiAgencyUserRequest) {
        const response = await this.addAgencyUserRaw({ apiAgencyUserRequest: apiAgencyUserRequest });
        return await response.value();
    }
    /**
     */
    async addBestPricePackageToBookingRaw(requestParameters) {
        if (requestParameters.packageId === null || requestParameters.packageId === undefined) {
            throw new RequiredError('packageId', 'Required parameter requestParameters.packageId was null or undefined when calling addBestPricePackageToBooking.');
        }
        if (requestParameters.packageDetailsId === null || requestParameters.packageDetailsId === undefined) {
            throw new RequiredError('packageDetailsId', 'Required parameter requestParameters.packageDetailsId was null or undefined when calling addBestPricePackageToBooking.');
        }
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling addBestPricePackageToBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/bestprice/{packageId}/{packageDetailsId}/addToBooking/{bookingId}`.replace(`{${"packageId"}}`, encodeURIComponent(String(requestParameters.packageId))).replace(`{${"packageDetailsId"}}`, encodeURIComponent(String(requestParameters.packageDetailsId))).replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     */
    async addBestPricePackageToBooking(packageId, packageDetailsId, bookingId) {
        const response = await this.addBestPricePackageToBookingRaw({ packageId: packageId, packageDetailsId: packageDetailsId, bookingId: bookingId });
        return await response.value();
    }
    /**
     * add a business partner
     */
    async addBusinessPartnerRaw(requestParameters) {
        if (requestParameters.apiAddBusinesPartnerRequest === null || requestParameters.apiAddBusinesPartnerRequest === undefined) {
            throw new RequiredError('apiAddBusinesPartnerRequest', 'Required parameter requestParameters.apiAddBusinesPartnerRequest was null or undefined when calling addBusinessPartner.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/businesspartner/addBusinessPartner`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiAddBusinesPartnerRequestFromJSONTyped(requestParameters.apiAddBusinesPartnerRequest),
        });
        return new TextApiResponse(response);
    }
    /**
     * add a business partner
     */
    async addBusinessPartner(apiAddBusinesPartnerRequest) {
        const response = await this.addBusinessPartnerRaw({ apiAddBusinesPartnerRequest: apiAddBusinesPartnerRequest });
        return await response.value();
    }
    /**
     */
    async addItemRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling addItem.');
        }
        if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
            throw new RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling addItem.');
        }
        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
            throw new RequiredError('itemId', 'Required parameter requestParameters.itemId was null or undefined when calling addItem.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/component/{componentId}/add/{itemId}`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters.itemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     */
    async addItem(packageCartId, componentId, itemId) {
        const response = await this.addItemRaw({ packageCartId: packageCartId, componentId: componentId, itemId: itemId });
        return await response.value();
    }
    /**
     * add item to booking
     */
    async addItemToBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling addItemToBooking.');
        }
        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
            throw new RequiredError('itemId', 'Required parameter requestParameters.itemId was null or undefined when calling addItemToBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/item/{itemId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters.itemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiAddItemRequestFromJSONTyped(requestParameters.apiAddItemRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * add item to booking
     */
    async addItemToBooking(bookingId, itemId, apiAddItemRequest) {
        const response = await this.addItemToBookingRaw({ bookingId: bookingId, itemId: itemId, apiAddItemRequest: apiAddItemRequest });
        return await response.value();
    }
    /**
     * add items to booking
     */
    async addItemsToBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling addItemsToBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/addItems`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * add items to booking
     */
    async addItemsToBooking(bookingId, requestBody) {
        const response = await this.addItemsToBookingRaw({ bookingId: bookingId, requestBody: requestBody });
        return await response.value();
    }
    /**
     * add promo Code to booking
     */
    async addPromoCodesRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling addPromoCodes.');
        }
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new RequiredError('requestBody', 'Required parameter requestParameters.requestBody was null or undefined when calling addPromoCodes.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/promoCodes`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * add promo Code to booking
     */
    async addPromoCodes(bookingId, requestBody) {
        const response = await this.addPromoCodesRaw({ bookingId: bookingId, requestBody: requestBody });
        return await response.value();
    }
    /**
     */
    async addToBookingRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling addToBooking.');
        }
        const queryParameters = {};
        if (requestParameters.bookingId !== undefined) {
            queryParameters['bookingId'] = requestParameters.bookingId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/addToBooking`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new VoidApiResponse(response);
    }
    /**
     */
    async addToBooking(packageCartId, bookingId) {
        await this.addToBookingRaw({ packageCartId: packageCartId, bookingId: bookingId });
    }
    /**
     * add traveler
     */
    async addTravelerRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling addTraveler.');
        }
        if (requestParameters.attempt === null || requestParameters.attempt === undefined) {
            throw new RequiredError('attempt', 'Required parameter requestParameters.attempt was null or undefined when calling addTraveler.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/traveler/{attempt}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))).replace(`{${"attempt"}}`, encodeURIComponent(String(requestParameters.attempt))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiTravelerFromJSONTyped(requestParameters.apiTraveler),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * add traveler
     */
    async addTraveler(bookingId, attempt, apiTraveler) {
        const response = await this.addTravelerRaw({ bookingId: bookingId, attempt: attempt, apiTraveler: apiTraveler });
        return await response.value();
    }
    /**
     * add voucher Code to booking
     */
    async addVoucherCodesRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling addVoucherCodes.');
        }
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new RequiredError('requestBody', 'Required parameter requestParameters.requestBody was null or undefined when calling addVoucherCodes.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/voucherCodes`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * add voucher Code to booking
     */
    async addVoucherCodes(bookingId, requestBody) {
        const response = await this.addVoucherCodesRaw({ bookingId: bookingId, requestBody: requestBody });
        return await response.value();
    }
    /**
     */
    async applyListOptionsRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling applyListOptions.');
        }
        if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
            throw new RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling applyListOptions.');
        }
        if (requestParameters.apiListOptions === null || requestParameters.apiListOptions === undefined) {
            throw new RequiredError('apiListOptions', 'Required parameter requestParameters.apiListOptions was null or undefined when calling applyListOptions.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/applyListOptions/{packageCartId}/component/{componentId}`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiListOptionsFromJSONTyped(requestParameters.apiListOptions),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiComponentListOptionResponseFromJSON(jsonValue));
    }
    /**
     */
    async applyListOptions(packageCartId, componentId, apiListOptions) {
        const response = await this.applyListOptionsRaw({ packageCartId: packageCartId, componentId: componentId, apiListOptions: apiListOptions });
        return await response.value();
    }
    /**
     * Apply Pax/Room Assignments to Booking
     */
    async applyPaxRoomAssignmentsRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling applyPaxRoomAssignments.');
        }
        if (requestParameters.apiApplyPaxRoomAssignmentRequest === null || requestParameters.apiApplyPaxRoomAssignmentRequest === undefined) {
            throw new RequiredError('apiApplyPaxRoomAssignmentRequest', 'Required parameter requestParameters.apiApplyPaxRoomAssignmentRequest was null or undefined when calling applyPaxRoomAssignments.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/bestprice/paxRoomAssignments/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiApplyPaxRoomAssignmentRequestFromJSONTyped(requestParameters.apiApplyPaxRoomAssignmentRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiApplyPaxRoomAssignmentResponseFromJSON(jsonValue));
    }
    /**
     * Apply Pax/Room Assignments to Booking
     */
    async applyPaxRoomAssignments(bookingId, apiApplyPaxRoomAssignmentRequest) {
        const response = await this.applyPaxRoomAssignmentsRaw({ bookingId: bookingId, apiApplyPaxRoomAssignmentRequest: apiApplyPaxRoomAssignmentRequest });
        return await response.value();
    }
    /**
     */
    async attemptBookingRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling attemptBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/attemptBooking`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     */
    async attemptBooking(packageCartId) {
        const response = await this.attemptBookingRaw({ packageCartId: packageCartId });
        return await response.value();
    }
    /**
     * Authenticate a User
     */
    async authenticateRaw(requestParameters) {
        if (requestParameters.apiAuthenticateRequest === null || requestParameters.apiAuthenticateRequest === undefined) {
            throw new RequiredError('apiAuthenticateRequest', 'Required parameter requestParameters.apiAuthenticateRequest was null or undefined when calling authenticate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/authentication/authenticate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiAuthenticateRequestFromJSONTyped(requestParameters.apiAuthenticateRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiAuthenticateResponseFromJSON(jsonValue));
    }
    /**
     * Authenticate a User
     */
    async authenticate(apiAuthenticateRequest) {
        const response = await this.authenticateRaw({ apiAuthenticateRequest: apiAuthenticateRequest });
        return await response.value();
    }
    /**
     * cancel  booking
     */
    async bookingCancelRaw(requestParameters) {
        if (requestParameters.apiBookingCancelRequest === null || requestParameters.apiBookingCancelRequest === undefined) {
            throw new RequiredError('apiBookingCancelRequest', 'Required parameter requestParameters.apiBookingCancelRequest was null or undefined when calling bookingCancel.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/cancel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiBookingCancelRequestFromJSONTyped(requestParameters.apiBookingCancelRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * cancel  booking
     */
    async bookingCancel(apiBookingCancelRequest) {
        const response = await this.bookingCancelRaw({ apiBookingCancelRequest: apiBookingCancelRequest });
        return await response.value();
    }
    /**
     * login by booking
     */
    async bookingLoginRaw(requestParameters) {
        if (requestParameters.apiBookingLoginRequest === null || requestParameters.apiBookingLoginRequest === undefined) {
            throw new RequiredError('apiBookingLoginRequest', 'Required parameter requestParameters.apiBookingLoginRequest was null or undefined when calling bookingLogin.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/bookingLogin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiBookingLoginRequestFromJSONTyped(requestParameters.apiBookingLoginRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * login by booking
     */
    async bookingLogin(apiBookingLoginRequest) {
        const response = await this.bookingLoginRaw({ apiBookingLoginRequest: apiBookingLoginRequest });
        return await response.value();
    }
    /**
     */
    async calculatePriceRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling calculatePrice.');
        }
        if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
            throw new RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling calculatePrice.');
        }
        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
            throw new RequiredError('itemId', 'Required parameter requestParameters.itemId was null or undefined when calling calculatePrice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/component/{componentId}/calculatePrice/{itemId}`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters.itemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPriceFromJSON(jsonValue));
    }
    /**
     */
    async calculatePrice(packageCartId, componentId, itemId) {
        const response = await this.calculatePriceRaw({ packageCartId: packageCartId, componentId: componentId, itemId: itemId });
        return await response.value();
    }
    /**
     */
    async changeComponentsRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling changeComponents.');
        }
        if (requestParameters.packageDetailId === null || requestParameters.packageDetailId === undefined) {
            throw new RequiredError('packageDetailId', 'Required parameter requestParameters.packageDetailId was null or undefined when calling changeComponents.');
        }
        if (requestParameters.apiChangeComponentsRequest === null || requestParameters.apiChangeComponentsRequest === undefined) {
            throw new RequiredError('apiChangeComponentsRequest', 'Required parameter requestParameters.apiChangeComponentsRequest was null or undefined when calling changeComponents.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/changeComponents/{packageDetailId}`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))).replace(`{${"packageDetailId"}}`, encodeURIComponent(String(requestParameters.packageDetailId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiChangeComponentsRequestFromJSONTyped(requestParameters.apiChangeComponentsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     */
    async changeComponents(packageCartId, packageDetailId, apiChangeComponentsRequest) {
        const response = await this.changeComponentsRaw({ packageCartId: packageCartId, packageDetailId: packageDetailId, apiChangeComponentsRequest: apiChangeComponentsRequest });
        return await response.value();
    }
    /**
     * change service date
     */
    async changeDateRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/service/changeDate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiChangeServiceDateRequestFromJSONTyped(requestParameters.apiChangeServiceDateRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * change service date
     */
    async changeDate(apiChangeServiceDateRequest) {
        const response = await this.changeDateRaw({ apiChangeServiceDateRequest: apiChangeServiceDateRequest });
        return await response.value();
    }
    /**
     * Change Password for a user
     */
    async changePasswordRaw(requestParameters) {
        if (requestParameters.apiChangePasswordRequest === null || requestParameters.apiChangePasswordRequest === undefined) {
            throw new RequiredError('apiChangePasswordRequest', 'Required parameter requestParameters.apiChangePasswordRequest was null or undefined when calling changePassword.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/authentication/changePassword`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiChangePasswordRequestFromJSONTyped(requestParameters.apiChangePasswordRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiApiBaseResponseFromJSON(jsonValue));
    }
    /**
     * Change Password for a user
     */
    async changePassword(apiChangePasswordRequest) {
        const response = await this.changePasswordRaw({ apiChangePasswordRequest: apiChangePasswordRequest });
        return await response.value();
    }
    /**
     * Creates activity
     */
    async createActivityRaw(requestParameters) {
        if (requestParameters.apiActivity === null || requestParameters.apiActivity === undefined) {
            throw new RequiredError('apiActivity', 'Required parameter requestParameters.apiActivity was null or undefined when calling createActivity.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/activity/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiActivityFromJSONTyped(requestParameters.apiActivity),
        });
        return new VoidApiResponse(response);
    }
    /**
     * Creates activity
     */
    async createActivity(apiActivity) {
        await this.createActivityRaw({ apiActivity: apiActivity });
    }
    /**
     * delete item from booking
     */
    async deleteItemFromBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling deleteItemFromBooking.');
        }
        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
            throw new RequiredError('itemId', 'Required parameter requestParameters.itemId was null or undefined when calling deleteItemFromBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/item/{itemId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters.itemId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * delete item from booking
     */
    async deleteItemFromBooking(bookingId, itemId) {
        const response = await this.deleteItemFromBookingRaw({ bookingId: bookingId, itemId: itemId });
        return await response.value();
    }
    /**
     * delete items from booking
     */
    async deleteItemsFromBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling deleteItemsFromBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/deleteItems`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * delete items from booking
     */
    async deleteItemsFromBooking(bookingId, requestBody) {
        const response = await this.deleteItemsFromBookingRaw({ bookingId: bookingId, requestBody: requestBody });
        return await response.value();
    }
    /**
     * send RQ to delete/deactivate token for booking
     */
    async deleteTokenForBookingRaw(requestParameters) {
        if (requestParameters.apiDeleteTokenForBookingRequest === null || requestParameters.apiDeleteTokenForBookingRequest === undefined) {
            throw new RequiredError('apiDeleteTokenForBookingRequest', 'Required parameter requestParameters.apiDeleteTokenForBookingRequest was null or undefined when calling deleteTokenForBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/deleteTokenForBooking`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiDeleteTokenForBookingRequestFromJSONTyped(requestParameters.apiDeleteTokenForBookingRequest),
        });
        return new VoidApiResponse(response);
    }
    /**
     * send RQ to delete/deactivate token for booking
     */
    async deleteTokenForBooking(apiDeleteTokenForBookingRequest) {
        await this.deleteTokenForBookingRaw({ apiDeleteTokenForBookingRequest: apiDeleteTokenForBookingRequest });
    }
    /**
     * attempt/persist a booking
     */
    async doAttemptBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling doAttemptBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/attempt/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * attempt/persist a booking
     */
    async doAttemptBooking(bookingId) {
        const response = await this.doAttemptBookingRaw({ bookingId: bookingId });
        return await response.value();
    }
    /**
     * book/persist a booking
     */
    async doBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling doBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/book/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * book/persist a booking
     */
    async doBooking(bookingId) {
        const response = await this.doBookingRaw({ bookingId: bookingId });
        return await response.value();
    }
    /**
     * book a Optionbooking
     */
    async doOptionBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling doOptionBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/option/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * book a Optionbooking
     */
    async doOptionBooking(bookingId) {
        const response = await this.doOptionBookingRaw({ bookingId: bookingId });
        return await response.value();
    }
    /**
     * book a Pendingbooking
     */
    async doPendingBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling doPendingBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/pending/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * book a Pendingbooking
     */
    async doPendingBooking(bookingId) {
        const response = await this.doPendingBookingRaw({ bookingId: bookingId });
        return await response.value();
    }
    /**
     * do voucher booking
     */
    async doVoucherBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling doVoucherBooking.');
        }
        if (requestParameters.attempt === null || requestParameters.attempt === undefined) {
            throw new RequiredError('attempt', 'Required parameter requestParameters.attempt was null or undefined when calling doVoucherBooking.');
        }
        if (requestParameters.apiVoucherBookingRequest === null || requestParameters.apiVoucherBookingRequest === undefined) {
            throw new RequiredError('apiVoucherBookingRequest', 'Required parameter requestParameters.apiVoucherBookingRequest was null or undefined when calling doVoucherBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/voucher/doBooking/{bookingId}/{attempt}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))).replace(`{${"attempt"}}`, encodeURIComponent(String(requestParameters.attempt))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiVoucherBookingRequestFromJSONTyped(requestParameters.apiVoucherBookingRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * do voucher booking
     */
    async doVoucherBooking(bookingId, attempt, apiVoucherBookingRequest) {
        const response = await this.doVoucherBookingRaw({ bookingId: bookingId, attempt: attempt, apiVoucherBookingRequest: apiVoucherBookingRequest });
        return await response.value();
    }
    /**
     * edit a user
     */
    async editAgencyUserRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/businesspartner/editAgencyUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiAgencyUserRequestFromJSONTyped(requestParameters.apiAgencyUserRequest),
        });
        return new TextApiResponse(response);
    }
    /**
     * edit a user
     */
    async editAgencyUser(apiAgencyUserRequest) {
        const response = await this.editAgencyUserRaw({ apiAgencyUserRequest: apiAgencyUserRequest });
        return await response.value();
    }
    /**
     * edit a business partner
     */
    async editBusinessPartnerRaw(requestParameters) {
        if (requestParameters.apiEditBusinesPartnerRequest === null || requestParameters.apiEditBusinesPartnerRequest === undefined) {
            throw new RequiredError('apiEditBusinesPartnerRequest', 'Required parameter requestParameters.apiEditBusinesPartnerRequest was null or undefined when calling editBusinessPartner.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/businesspartner/editBusinessPartner`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiEditBusinesPartnerRequestFromJSONTyped(requestParameters.apiEditBusinesPartnerRequest),
        });
        return new TextApiResponse(response);
    }
    /**
     * edit a business partner
     */
    async editBusinessPartner(apiEditBusinesPartnerRequest) {
        const response = await this.editBusinessPartnerRaw({ apiEditBusinesPartnerRequest: apiEditBusinesPartnerRequest });
        return await response.value();
    }
    /**
     * fetch agency
     */
    async fetchAgencyRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/businesspartner/fetchAgency`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiFetchAgencyRequestFromJSONTyped(requestParameters.apiFetchAgencyRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiAgencyFromJSON(jsonValue));
    }
    /**
     * fetch agency
     */
    async fetchAgency(apiFetchAgencyRequest) {
        const response = await this.fetchAgencyRaw({ apiFetchAgencyRequest: apiFetchAgencyRequest });
        return await response.value();
    }
    /**
     * Fetches details for a package component
     */
    async fetchPackageDetailsForComponentRaw(requestParameters) {
        if (requestParameters.packageId === null || requestParameters.packageId === undefined) {
            throw new RequiredError('packageId', 'Required parameter requestParameters.packageId was null or undefined when calling fetchPackageDetailsForComponent.');
        }
        if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
            throw new RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling fetchPackageDetailsForComponent.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/fetchDetails/{packageId}/component/{componentId}`.replace(`{${"packageId"}}`, encodeURIComponent(String(requestParameters.packageId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     * Fetches details for a package component
     */
    async fetchPackageDetailsForComponent(packageId, componentId) {
        const response = await this.fetchPackageDetailsForComponentRaw({ packageId: packageId, componentId: componentId });
        return await response.value();
    }
    /**
     * Generates booking documents
     */
    async generateBookingDocumentsRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling generateBookingDocuments.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/documents/generate`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * Generates booking documents
     */
    async generateBookingDocuments(bookingId) {
        const response = await this.generateBookingDocumentsRaw({ bookingId: bookingId });
        return await response.value();
    }
    /**
     * get non sensitive data for affiliate
     */
    async getAffiliateDataRaw(requestParameters) {
        if (requestParameters.apiAffiliateRequest === null || requestParameters.apiAffiliateRequest === undefined) {
            throw new RequiredError('apiAffiliateRequest', 'Required parameter requestParameters.apiAffiliateRequest was null or undefined when calling getAffiliateData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/affiliate/getAffiliateData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiAffiliateRequestFromJSONTyped(requestParameters.apiAffiliateRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiAffiliateResponseFromJSON(jsonValue));
    }
    /**
     * get non sensitive data for affiliate
     */
    async getAffiliateData(apiAffiliateRequest) {
        const response = await this.getAffiliateDataRaw({ apiAffiliateRequest: apiAffiliateRequest });
        return await response.value();
    }
    /**
     * get the creditlimit
     */
    async getAgencyCreditLimitRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/businesspartner/getAgencyCreditLimit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetAgencyCreditLimitResponseFromJSON(jsonValue));
    }
    /**
     * get the creditlimit
     */
    async getAgencyCreditLimit() {
        const response = await this.getAgencyCreditLimitRaw();
        return await response.value();
    }
    /**
     * Get attractions availability info
     */
    async getAttractionsAvailabilityInfoRaw(requestParameters) {
        if (requestParameters.apiGetAttractionAvailabilityRequest === null || requestParameters.apiGetAttractionAvailabilityRequest === undefined) {
            throw new RequiredError('apiGetAttractionAvailabilityRequest', 'Required parameter requestParameters.apiGetAttractionAvailabilityRequest was null or undefined when calling getAttractionsAvailabilityInfo.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getAttractionsAvailabilityInfo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetAttractionAvailabilityRequestFromJSONTyped(requestParameters.apiGetAttractionAvailabilityRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiAttractionAvailabilityInfoFromJSON));
    }
    /**
     * Get attractions availability info
     */
    async getAttractionsAvailabilityInfo(apiGetAttractionAvailabilityRequest) {
        const response = await this.getAttractionsAvailabilityInfoRaw({ apiGetAttractionAvailabilityRequest: apiGetAttractionAvailabilityRequest });
        return await response.value();
    }
    /**
     * retrieve a booking
     */
    async getBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling getBooking.');
        }
        const queryParameters = {};
        if (requestParameters.noCache !== undefined) {
            queryParameters['noCache'] = requestParameters.noCache;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * retrieve a booking
     */
    async getBooking(bookingId, noCache) {
        const response = await this.getBookingRaw({ bookingId: bookingId, noCache: noCache });
        return await response.value();
    }
    /**
     * Get agency and business partner information.
     */
    async getBusinessPartnerRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/businesspartner/retrieve`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetBusinessPartnerResponseFromJSON(jsonValue));
    }
    /**
     * Get agency and business partner information.
     */
    async getBusinessPartner() {
        const response = await this.getBusinessPartnerRaw();
        return await response.value();
    }
    /**
     * Details for a camper
     */
    async getCamperDetailsRaw(requestParameters) {
        if (requestParameters.apiGetCamperDetailsRequest === null || requestParameters.apiGetCamperDetailsRequest === undefined) {
            throw new RequiredError('apiGetCamperDetailsRequest', 'Required parameter requestParameters.apiGetCamperDetailsRequest was null or undefined when calling getCamperDetails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/camper/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetCamperDetailsRequestFromJSONTyped(requestParameters.apiGetCamperDetailsRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetCamperDetailsResponseFromJSON(jsonValue));
    }
    /**
     * Details for a camper
     */
    async getCamperDetails(apiGetCamperDetailsRequest) {
        const response = await this.getCamperDetailsRaw({ apiGetCamperDetailsRequest: apiGetCamperDetailsRequest });
        return await response.value();
    }
    /**
     * Search for insurances that can be booked with a camper
     */
    async getCamperInsuranceListRaw(requestParameters) {
        if (requestParameters.apiGetAdditionalInsuranceListRequest === null || requestParameters.apiGetAdditionalInsuranceListRequest === undefined) {
            throw new RequiredError('apiGetAdditionalInsuranceListRequest', 'Required parameter requestParameters.apiGetAdditionalInsuranceListRequest was null or undefined when calling getCamperInsuranceList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/camper/insurance/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetAdditionalInsuranceListRequestFromJSONTyped(requestParameters.apiGetAdditionalInsuranceListRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetAdditionalInsuranceListResponseFromJSON(jsonValue));
    }
    /**
     * Search for insurances that can be booked with a camper
     */
    async getCamperInsuranceList(apiGetAdditionalInsuranceListRequest) {
        const response = await this.getCamperInsuranceListRaw({ apiGetAdditionalInsuranceListRequest: apiGetAdditionalInsuranceListRequest });
        return await response.value();
    }
    /**
     * Search for campers
     */
    async getCamperListRaw(requestParameters) {
        if (requestParameters.apiGetCamperListRequest === null || requestParameters.apiGetCamperListRequest === undefined) {
            throw new RequiredError('apiGetCamperListRequest', 'Required parameter requestParameters.apiGetCamperListRequest was null or undefined when calling getCamperList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/camper/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetCamperListRequestFromJSONTyped(requestParameters.apiGetCamperListRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetCamperListResponseFromJSON(jsonValue));
    }
    /**
     * Search for campers
     */
    async getCamperList(apiGetCamperListRequest) {
        const response = await this.getCamperListRaw({ apiGetCamperListRequest: apiGetCamperListRequest });
        return await response.value();
    }
    /**
     * Terms and conditions for a camper
     */
    async getCamperTermsAndConditionsRaw(requestParameters) {
        if (requestParameters.apiGetCamperTermsAndConditionsRequest === null || requestParameters.apiGetCamperTermsAndConditionsRequest === undefined) {
            throw new RequiredError('apiGetCamperTermsAndConditionsRequest', 'Required parameter requestParameters.apiGetCamperTermsAndConditionsRequest was null or undefined when calling getCamperTermsAndConditions.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/camper/terms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetCamperTermsAndConditionsRequestFromJSONTyped(requestParameters.apiGetCamperTermsAndConditionsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetCamperTermsAndConditionsResponseFromJSON(jsonValue));
    }
    /**
     * Terms and conditions for a camper
     */
    async getCamperTermsAndConditions(apiGetCamperTermsAndConditionsRequest) {
        const response = await this.getCamperTermsAndConditionsRaw({ apiGetCamperTermsAndConditionsRequest: apiGetCamperTermsAndConditionsRequest });
        return await response.value();
    }
    /**
     * Get configuration data from Pacific.
     */
    async getConfigurationRaw(requestParameters) {
        if (requestParameters.apiConfigurationDataRequest === null || requestParameters.apiConfigurationDataRequest === undefined) {
            throw new RequiredError('apiConfigurationDataRequest', 'Required parameter requestParameters.apiConfigurationDataRequest was null or undefined when calling getConfiguration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getConfigurationData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiConfigurationDataRequestFromJSONTyped(requestParameters.apiConfigurationDataRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiConfigurationDataResponseFromJSON(jsonValue));
    }
    /**
     * Get configuration data from Pacific.
     */
    async getConfiguration(apiConfigurationDataRequest) {
        const response = await this.getConfigurationRaw({ apiConfigurationDataRequest: apiConfigurationDataRequest });
        return await response.value();
    }
    /**
     * Get countries from Pacific.
     */
    async getCountriesRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getCountries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetGeoUnitsResponseFromJSON(jsonValue));
    }
    /**
     * Get countries from Pacific.
     */
    async getCountries() {
        const response = await this.getCountriesRaw();
        return await response.value();
    }
    /**
     * get all Countries
     */
    async getCountriesListRaw(requestParameters) {
        if (requestParameters.languageCode === null || requestParameters.languageCode === undefined) {
            throw new RequiredError('languageCode', 'Required parameter requestParameters.languageCode was null or undefined when calling getCountriesList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.languageCode !== undefined && requestParameters.languageCode !== null) {
            headerParameters['languageCode'] = String(requestParameters.languageCode);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/fastsearch/getCountriesList`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetCountriesListResponseFromJSON(jsonValue));
    }
    /**
     * get all Countries
     */
    async getCountriesList(languageCode) {
        const response = await this.getCountriesListRaw({ languageCode: languageCode });
        return await response.value();
    }
    /**
     * Get destination airports from Pacific.
     */
    async getDestinationAirportsRaw(requestParameters) {
        if (requestParameters.apiGetGeoUnitsRequest === null || requestParameters.apiGetGeoUnitsRequest === undefined) {
            throw new RequiredError('apiGetGeoUnitsRequest', 'Required parameter requestParameters.apiGetGeoUnitsRequest was null or undefined when calling getDestinationAirports.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getDestinationAirports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetGeoUnitsRequestFromJSONTyped(requestParameters.apiGetGeoUnitsRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetGeoUnitsResponseFromJSON(jsonValue));
    }
    /**
     * Get destination airports from Pacific.
     */
    async getDestinationAirports(apiGetGeoUnitsRequest) {
        const response = await this.getDestinationAirportsRaw({ apiGetGeoUnitsRequest: apiGetGeoUnitsRequest });
        return await response.value();
    }
    /**
     * Gets booking document
     */
    async getDocumentRaw(requestParameters) {
        if (requestParameters.bookingNumber === null || requestParameters.bookingNumber === undefined) {
            throw new RequiredError('bookingNumber', 'Required parameter requestParameters.bookingNumber was null or undefined when calling getDocument.');
        }
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new RequiredError('documentId', 'Required parameter requestParameters.documentId was null or undefined when calling getDocument.');
        }
        if (requestParameters.documentType === null || requestParameters.documentType === undefined) {
            throw new RequiredError('documentType', 'Required parameter requestParameters.documentType was null or undefined when calling getDocument.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/document/{bookingNumber}/{documentId}/{documentType}`.replace(`{${"bookingNumber"}}`, encodeURIComponent(String(requestParameters.bookingNumber))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"documentType"}}`, encodeURIComponent(String(requestParameters.documentType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new BlobApiResponse(response);
    }
    /**
     * Gets booking document
     */
    async getDocument(bookingNumber, documentId, documentType) {
        const response = await this.getDocumentRaw({ bookingNumber: bookingNumber, documentId: documentId, documentType: documentType });
        return await response.value();
    }
    /**
     * Gets booking document
     */
    async getDocumentUsingSubTypeRaw(requestParameters) {
        if (requestParameters.bookingNumber === null || requestParameters.bookingNumber === undefined) {
            throw new RequiredError('bookingNumber', 'Required parameter requestParameters.bookingNumber was null or undefined when calling getDocumentUsingSubType.');
        }
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new RequiredError('documentId', 'Required parameter requestParameters.documentId was null or undefined when calling getDocumentUsingSubType.');
        }
        if (requestParameters.documentType === null || requestParameters.documentType === undefined) {
            throw new RequiredError('documentType', 'Required parameter requestParameters.documentType was null or undefined when calling getDocumentUsingSubType.');
        }
        if (requestParameters.documentSubType === null || requestParameters.documentSubType === undefined) {
            throw new RequiredError('documentSubType', 'Required parameter requestParameters.documentSubType was null or undefined when calling getDocumentUsingSubType.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/document/{bookingNumber}/{documentId}/{documentType}/{documentSubType}`.replace(`{${"bookingNumber"}}`, encodeURIComponent(String(requestParameters.bookingNumber))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"documentType"}}`, encodeURIComponent(String(requestParameters.documentType))).replace(`{${"documentSubType"}}`, encodeURIComponent(String(requestParameters.documentSubType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new BlobApiResponse(response);
    }
    /**
     * Gets booking document
     */
    async getDocumentUsingSubType(bookingNumber, documentId, documentType, documentSubType) {
        const response = await this.getDocumentUsingSubTypeRaw({ bookingNumber: bookingNumber, documentId: documentId, documentType: documentType, documentSubType: documentSubType });
        return await response.value();
    }
    /**
     * Gets booking document
     */
    async getDocumentUsingSubTypeAndFileNameRaw(requestParameters) {
        if (requestParameters.bookingNumber === null || requestParameters.bookingNumber === undefined) {
            throw new RequiredError('bookingNumber', 'Required parameter requestParameters.bookingNumber was null or undefined when calling getDocumentUsingSubTypeAndFileName.');
        }
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new RequiredError('documentId', 'Required parameter requestParameters.documentId was null or undefined when calling getDocumentUsingSubTypeAndFileName.');
        }
        if (requestParameters.documentType === null || requestParameters.documentType === undefined) {
            throw new RequiredError('documentType', 'Required parameter requestParameters.documentType was null or undefined when calling getDocumentUsingSubTypeAndFileName.');
        }
        if (requestParameters.documentSubType === null || requestParameters.documentSubType === undefined) {
            throw new RequiredError('documentSubType', 'Required parameter requestParameters.documentSubType was null or undefined when calling getDocumentUsingSubTypeAndFileName.');
        }
        if (requestParameters.documentFileName === null || requestParameters.documentFileName === undefined) {
            throw new RequiredError('documentFileName', 'Required parameter requestParameters.documentFileName was null or undefined when calling getDocumentUsingSubTypeAndFileName.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/document/{bookingNumber}/{documentId}/{documentType}/{documentSubType}/{documentFileName}`.replace(`{${"bookingNumber"}}`, encodeURIComponent(String(requestParameters.bookingNumber))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))).replace(`{${"documentType"}}`, encodeURIComponent(String(requestParameters.documentType))).replace(`{${"documentSubType"}}`, encodeURIComponent(String(requestParameters.documentSubType))).replace(`{${"documentFileName"}}`, encodeURIComponent(String(requestParameters.documentFileName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new BlobApiResponse(response);
    }
    /**
     * Gets booking document
     */
    async getDocumentUsingSubTypeAndFileName(bookingNumber, documentId, documentType, documentSubType, documentFileName) {
        const response = await this.getDocumentUsingSubTypeAndFileNameRaw({ bookingNumber: bookingNumber, documentId: documentId, documentType: documentType, documentSubType: documentSubType, documentFileName: documentFileName });
        return await response.value();
    }
    /**
     * Details for a additional item
     */
    async getExtraServiceDetailsRaw(requestParameters) {
        if (requestParameters.apiGetExtraServiceRequest === null || requestParameters.apiGetExtraServiceRequest === undefined) {
            throw new RequiredError('apiGetExtraServiceRequest', 'Required parameter requestParameters.apiGetExtraServiceRequest was null or undefined when calling getExtraServiceDetails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/extra/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetExtraServiceRequestFromJSONTyped(requestParameters.apiGetExtraServiceRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetExtraServiceResponseFromJSON(jsonValue));
    }
    /**
     * Details for a additional item
     */
    async getExtraServiceDetails(apiGetExtraServiceRequest) {
        const response = await this.getExtraServiceDetailsRaw({ apiGetExtraServiceRequest: apiGetExtraServiceRequest });
        return await response.value();
    }
    /**
     * Search for additional items
     */
    async getExtraServiceListRaw(requestParameters) {
        if (requestParameters.apiGetExtraServiceListRequest === null || requestParameters.apiGetExtraServiceListRequest === undefined) {
            throw new RequiredError('apiGetExtraServiceListRequest', 'Required parameter requestParameters.apiGetExtraServiceListRequest was null or undefined when calling getExtraServiceList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/extra/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetExtraServiceListRequestFromJSONTyped(requestParameters.apiGetExtraServiceListRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetExtraServiceListResponseFromJSON(jsonValue));
    }
    /**
     * Search for additional items
     */
    async getExtraServiceList(apiGetExtraServiceListRequest) {
        const response = await this.getExtraServiceListRaw({ apiGetExtraServiceListRequest: apiGetExtraServiceListRequest });
        return await response.value();
    }
    /**
     * Search for flights
     */
    async getFlightListRaw(requestParameters) {
        if (requestParameters.apiGetFlightListRequest === null || requestParameters.apiGetFlightListRequest === undefined) {
            throw new RequiredError('apiGetFlightListRequest', 'Required parameter requestParameters.apiGetFlightListRequest was null or undefined when calling getFlightList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/getFlightList`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetFlightListRequestFromJSONTyped(requestParameters.apiGetFlightListRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetFlightListResponseFromJSON(jsonValue));
    }
    /**
     * Search for flights
     */
    async getFlightList(apiGetFlightListRequest) {
        const response = await this.getFlightListRaw({ apiGetFlightListRequest: apiGetFlightListRequest });
        return await response.value();
    }
    /**
     */
    async getFlightTripBookingResponseRaw(requestParameters) {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new RequiredError('uuid', 'Required parameter requestParameters.uuid was null or undefined when calling getFlightTripBookingResponse.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/flighttrip/get/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetFlightTripBookingResponseFromJSON(jsonValue));
    }
    /**
     */
    async getFlightTripBookingResponse(uuid) {
        const response = await this.getFlightTripBookingResponseRaw({ uuid: uuid });
        return await response.value();
    }
    /**
     * For a single GeoUnit, query the rules that define how the GeoUnit can be combined with, or applied to, other base data.
     */
    async getGeoUnitRulesRaw(requestParameters) {
        if (requestParameters.apiGetGeoUnitRulesRequest === null || requestParameters.apiGetGeoUnitRulesRequest === undefined) {
            throw new RequiredError('apiGetGeoUnitRulesRequest', 'Required parameter requestParameters.apiGetGeoUnitRulesRequest was null or undefined when calling getGeoUnitRules.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getGeoUnitRules`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetGeoUnitRulesRequestFromJSONTyped(requestParameters.apiGetGeoUnitRulesRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetGeoUnitRulesResponseFromJSON(jsonValue));
    }
    /**
     * For a single GeoUnit, query the rules that define how the GeoUnit can be combined with, or applied to, other base data.
     */
    async getGeoUnitRules(apiGetGeoUnitRulesRequest) {
        const response = await this.getGeoUnitRulesRaw({ apiGetGeoUnitRulesRequest: apiGetGeoUnitRulesRequest });
        return await response.value();
    }
    /**
     * Geographical units the application and services are based on. Usually this data is some kind of master data and may be cached. There may be different kind of geographical unit types, like \'CITY\', \'REGION\' or \'COUNTRY\'.
     */
    async getGeoUnitsRaw(requestParameters) {
        if (requestParameters.apiGetGeoUnitsRequest === null || requestParameters.apiGetGeoUnitsRequest === undefined) {
            throw new RequiredError('apiGetGeoUnitsRequest', 'Required parameter requestParameters.apiGetGeoUnitsRequest was null or undefined when calling getGeoUnits.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getGeoUnits`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetGeoUnitsRequestFromJSONTyped(requestParameters.apiGetGeoUnitsRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetGeoUnitsResponseFromJSON(jsonValue));
    }
    /**
     * Geographical units the application and services are based on. Usually this data is some kind of master data and may be cached. There may be different kind of geographical unit types, like \'CITY\', \'REGION\' or \'COUNTRY\'.
     */
    async getGeoUnits(apiGetGeoUnitsRequest) {
        const response = await this.getGeoUnitsRaw({ apiGetGeoUnitsRequest: apiGetGeoUnitsRequest });
        return await response.value();
    }
    /**
     * Searches prices for hotels all around the world
     */
    async getGroupedHotelPricesRaw(requestParameters) {
        if (requestParameters.apiGetGroupedHotelPricesRequest === null || requestParameters.apiGetGroupedHotelPricesRequest === undefined) {
            throw new RequiredError('apiGetGroupedHotelPricesRequest', 'Required parameter requestParameters.apiGetGroupedHotelPricesRequest was null or undefined when calling getGroupedHotelPrices.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/fastsearch/getGroupedHotelPrices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetGroupedHotelPricesRequestFromJSONTyped(requestParameters.apiGetGroupedHotelPricesRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetGroupedHotelPricesResponseFromJSON(jsonValue));
    }
    /**
     * Searches prices for hotels all around the world
     */
    async getGroupedHotelPrices(apiGetGroupedHotelPricesRequest) {
        const response = await this.getGroupedHotelPricesRaw({ apiGetGroupedHotelPricesRequest: apiGetGroupedHotelPricesRequest });
        return await response.value();
    }
    /**
     * Simple ping
     */
    async getHealthPingRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/health/ping`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new VoidApiResponse(response);
    }
    /**
     * Simple ping
     */
    async getHealthPing() {
        await this.getHealthPingRaw();
    }
    /**
     * get Hotel Characteristics
     */
    async getHotelCharacteristicsRaw(requestParameters) {
        if (requestParameters.languageCode === null || requestParameters.languageCode === undefined) {
            throw new RequiredError('languageCode', 'Required parameter requestParameters.languageCode was null or undefined when calling getHotelCharacteristics.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.languageCode !== undefined && requestParameters.languageCode !== null) {
            headerParameters['languageCode'] = String(requestParameters.languageCode);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/fastsearch/getHotelCharacteristics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetHotelCharacteristicsResponseFromJSON(jsonValue));
    }
    /**
     * get Hotel Characteristics
     */
    async getHotelCharacteristics(languageCode) {
        const response = await this.getHotelCharacteristicsRaw({ languageCode: languageCode });
        return await response.value();
    }
    /**
     * Details for a hotel
     */
    async getHotelDetailsRaw(requestParameters) {
        if (requestParameters.apiGetHotelDetailsRequest === null || requestParameters.apiGetHotelDetailsRequest === undefined) {
            throw new RequiredError('apiGetHotelDetailsRequest', 'Required parameter requestParameters.apiGetHotelDetailsRequest was null or undefined when calling getHotelDetails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/hotel/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetHotelDetailsRequestFromJSONTyped(requestParameters.apiGetHotelDetailsRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetHotelDetailsResponseFromJSON(jsonValue));
    }
    /**
     * Details for a hotel
     */
    async getHotelDetails(apiGetHotelDetailsRequest) {
        const response = await this.getHotelDetailsRaw({ apiGetHotelDetailsRequest: apiGetHotelDetailsRequest });
        return await response.value();
    }
    /**
     * Search for hotels
     */
    async getHotelListRaw(requestParameters) {
        if (requestParameters.apiGetHotelListRequest === null || requestParameters.apiGetHotelListRequest === undefined) {
            throw new RequiredError('apiGetHotelListRequest', 'Required parameter requestParameters.apiGetHotelListRequest was null or undefined when calling getHotelList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/hotel/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetHotelListRequestFromJSONTyped(requestParameters.apiGetHotelListRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetHotelListResponseFromJSON(jsonValue));
    }
    /**
     * Search for hotels
     */
    async getHotelList(apiGetHotelListRequest) {
        const response = await this.getHotelListRaw({ apiGetHotelListRequest: apiGetHotelListRequest });
        return await response.value();
    }
    /**
     * Searches prices for a hotel.
     */
    async getHotelPriceCurveRaw(requestParameters) {
        if (requestParameters.apiGetHotelPriceCurveRequest === null || requestParameters.apiGetHotelPriceCurveRequest === undefined) {
            throw new RequiredError('apiGetHotelPriceCurveRequest', 'Required parameter requestParameters.apiGetHotelPriceCurveRequest was null or undefined when calling getHotelPriceCurve.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/fastsearch/getHotelPriceCurve`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetHotelPriceCurveRequestFromJSONTyped(requestParameters.apiGetHotelPriceCurveRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetHotelPriceCurveResponseFromJSON(jsonValue));
    }
    /**
     * Searches prices for a hotel.
     */
    async getHotelPriceCurve(apiGetHotelPriceCurveRequest) {
        const response = await this.getHotelPriceCurveRaw({ apiGetHotelPriceCurveRequest: apiGetHotelPriceCurveRequest });
        return await response.value();
    }
    /**
     * Searches prices for hotels in a specific region
     */
    async getHotelsByTaretRaw(requestParameters) {
        if (requestParameters.apiGetHotelsByTargetRequest === null || requestParameters.apiGetHotelsByTargetRequest === undefined) {
            throw new RequiredError('apiGetHotelsByTargetRequest', 'Required parameter requestParameters.apiGetHotelsByTargetRequest was null or undefined when calling getHotelsByTaret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/fastsearch/getHotelsByTaret`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetHotelsByTargetRequestFromJSONTyped(requestParameters.apiGetHotelsByTargetRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetHotelsByTargetResponseFromJSON(jsonValue));
    }
    /**
     * Searches prices for hotels in a specific region
     */
    async getHotelsByTaret(apiGetHotelsByTargetRequest) {
        const response = await this.getHotelsByTaretRaw({ apiGetHotelsByTargetRequest: apiGetHotelsByTargetRequest });
        return await response.value();
    }
    /**
     * Details for a insurance
     */
    async getInsuranceDetailsRaw(requestParameters) {
        if (requestParameters.apiGetInsuranceDetailsRequest === null || requestParameters.apiGetInsuranceDetailsRequest === undefined) {
            throw new RequiredError('apiGetInsuranceDetailsRequest', 'Required parameter requestParameters.apiGetInsuranceDetailsRequest was null or undefined when calling getInsuranceDetails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/insurance/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetInsuranceDetailsRequestFromJSONTyped(requestParameters.apiGetInsuranceDetailsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetInsuranceDetailsResponseFromJSON(jsonValue));
    }
    /**
     * Details for a insurance
     */
    async getInsuranceDetails(apiGetInsuranceDetailsRequest) {
        const response = await this.getInsuranceDetailsRaw({ apiGetInsuranceDetailsRequest: apiGetInsuranceDetailsRequest });
        return await response.value();
    }
    /**
     * Search for insurances
     */
    async getInsuranceListRaw(requestParameters) {
        if (requestParameters.apiGetInsuranceListRequest === null || requestParameters.apiGetInsuranceListRequest === undefined) {
            throw new RequiredError('apiGetInsuranceListRequest', 'Required parameter requestParameters.apiGetInsuranceListRequest was null or undefined when calling getInsuranceList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/insurance/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetInsuranceListRequestFromJSONTyped(requestParameters.apiGetInsuranceListRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetInsuranceListResponseFromJSON(jsonValue));
    }
    /**
     * Search for insurances
     */
    async getInsuranceList(apiGetInsuranceListRequest) {
        const response = await this.getInsuranceListRaw({ apiGetInsuranceListRequest: apiGetInsuranceListRequest });
        return await response.value();
    }
    /**
     * get configured inventories by itemType
     */
    async getInventoriesByItemTypeRaw(requestParameters) {
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getInventoriesByItemType.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/vacancyConfiguration/getInvetoriesByItemType/{type}`.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response);
    }
    /**
     * get configured inventories by itemType
     */
    async getInventoriesByItemType(type) {
        const response = await this.getInventoriesByItemTypeRaw({ type: type });
        return await response.value();
    }
    /**
     * Details for a trip
     */
    async getItemTripDetailsRaw(requestParameters) {
        if (requestParameters.apiGetItemTripRequest === null || requestParameters.apiGetItemTripRequest === undefined) {
            throw new RequiredError('apiGetItemTripRequest', 'Required parameter requestParameters.apiGetItemTripRequest was null or undefined when calling getItemTripDetails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/tripitem/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetItemTripRequestFromJSONTyped(requestParameters.apiGetItemTripRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetItemTripResponseFromJSON(jsonValue));
    }
    /**
     * Details for a trip
     */
    async getItemTripDetails(apiGetItemTripRequest) {
        const response = await this.getItemTripDetailsRaw({ apiGetItemTripRequest: apiGetItemTripRequest });
        return await response.value();
    }
    /**
     * Search for trips
     */
    async getItemTripListRaw(requestParameters) {
        if (requestParameters.apiGetItemTripListRequest === null || requestParameters.apiGetItemTripListRequest === undefined) {
            throw new RequiredError('apiGetItemTripListRequest', 'Required parameter requestParameters.apiGetItemTripListRequest was null or undefined when calling getItemTripList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/tripitem/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetItemTripListRequestFromJSONTyped(requestParameters.apiGetItemTripListRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetItemTripListResponseFromJSON(jsonValue));
    }
    /**
     * Search for trips
     */
    async getItemTripList(apiGetItemTripListRequest) {
        const response = await this.getItemTripListRaw({ apiGetItemTripListRequest: apiGetItemTripListRequest });
        return await response.value();
    }
    /**
     * Get origin/destination Location relations.
     */
    async getLocationRelationsRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/location/relations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetLocationRelationsResponseFromJSON(jsonValue));
    }
    /**
     * Get origin/destination Location relations.
     */
    async getLocationRelations() {
        const response = await this.getLocationRelationsRaw();
        return await response.value();
    }
    /**
     * Get a list of offers for a specific itemType
     */
    async getOfferListRaw(requestParameters) {
        if (requestParameters.apiGetOfferListRequest === null || requestParameters.apiGetOfferListRequest === undefined) {
            throw new RequiredError('apiGetOfferListRequest', 'Required parameter requestParameters.apiGetOfferListRequest was null or undefined when calling getOfferList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/offer/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetOfferListRequestFromJSONTyped(requestParameters.apiGetOfferListRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetOfferListResponseFromJSON(jsonValue));
    }
    /**
     * Get a list of offers for a specific itemType
     */
    async getOfferList(apiGetOfferListRequest) {
        const response = await this.getOfferListRaw({ apiGetOfferListRequest: apiGetOfferListRequest });
        return await response.value();
    }
    /**
     * Get origin airports from Pacific.
     */
    async getOriginAirportsRaw(requestParameters) {
        if (requestParameters.apiGetGeoUnitsRequest === null || requestParameters.apiGetGeoUnitsRequest === undefined) {
            throw new RequiredError('apiGetGeoUnitsRequest', 'Required parameter requestParameters.apiGetGeoUnitsRequest was null or undefined when calling getOriginAirports.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getOriginAirports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetGeoUnitsRequestFromJSONTyped(requestParameters.apiGetGeoUnitsRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetGeoUnitsResponseFromJSON(jsonValue));
    }
    /**
     * Get origin airports from Pacific.
     */
    async getOriginAirports(apiGetGeoUnitsRequest) {
        const response = await this.getOriginAirportsRaw({ apiGetGeoUnitsRequest: apiGetGeoUnitsRequest });
        return await response.value();
    }
    /**
     * Get overlay seatmap
     */
    async getOverlaySeatMapRaw(requestParameters) {
        if (requestParameters.apiOverlaySeatMapRequest === null || requestParameters.apiOverlaySeatMapRequest === undefined) {
            throw new RequiredError('apiOverlaySeatMapRequest', 'Required parameter requestParameters.apiOverlaySeatMapRequest was null or undefined when calling getOverlaySeatMap.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/overlayseatmap/getOverlaySeatMap`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiOverlaySeatMapRequestFromJSONTyped(requestParameters.apiOverlaySeatMapRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiOverlaySeatMapResponseFromJSON(jsonValue));
    }
    /**
     * Get overlay seatmap
     */
    async getOverlaySeatMap(apiOverlaySeatMapRequest) {
        const response = await this.getOverlaySeatMapRaw({ apiOverlaySeatMapRequest: apiOverlaySeatMapRequest });
        return await response.value();
    }
    /**
     * Get overlay seatmap graphic
     */
    async getOverlaySeatMapGraphicRaw(requestParameters) {
        if (requestParameters.seatMapPatternCode === null || requestParameters.seatMapPatternCode === undefined) {
            throw new RequiredError('seatMapPatternCode', 'Required parameter requestParameters.seatMapPatternCode was null or undefined when calling getOverlaySeatMapGraphic.');
        }
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling getOverlaySeatMapGraphic.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/overlayseatmap/getOverlaySeatMapGraphic/{seatMapPatternCode}/{sessionId}`.replace(`{${"seatMapPatternCode"}}`, encodeURIComponent(String(requestParameters.seatMapPatternCode))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new BlobApiResponse(response);
    }
    /**
     * Get overlay seatmap graphic
     */
    async getOverlaySeatMapGraphic(seatMapPatternCode, sessionId) {
        const response = await this.getOverlaySeatMapGraphicRaw({ seatMapPatternCode: seatMapPatternCode, sessionId: sessionId });
        return await response.value();
    }
    /**
     * Search for package availability
     */
    async getPackageAvailabilityRaw(requestParameters) {
        if (requestParameters.apiGetPackagesRequest === null || requestParameters.apiGetPackagesRequest === undefined) {
            throw new RequiredError('apiGetPackagesRequest', 'Required parameter requestParameters.apiGetPackagesRequest was null or undefined when calling getPackageAvailability.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/availability`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetPackagesRequestFromJSONTyped(requestParameters.apiGetPackagesRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetPackagesResponseFromJSON(jsonValue));
    }
    /**
     * Search for package availability
     */
    async getPackageAvailability(apiGetPackagesRequest) {
        const response = await this.getPackageAvailabilityRaw({ apiGetPackagesRequest: apiGetPackagesRequest });
        return await response.value();
    }
    /**
     * retrieve components for given package
     */
    async getPackageComponentsRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/components`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetPackageComponentsRQFromJSONTyped(requestParameters.apiGetPackageComponentsRQ),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetPackageComponentsRSFromJSON(jsonValue));
    }
    /**
     * retrieve components for given package
     */
    async getPackageComponents(apiGetPackageComponentsRQ) {
        const response = await this.getPackageComponentsRaw({ apiGetPackageComponentsRQ: apiGetPackageComponentsRQ });
        return await response.value();
    }
    /**
     * Get package definition list.
     */
    async getPackagesDefinitionsRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/definitions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiPackageModelDefinitionFromJSON));
    }
    /**
     * Get package definition list.
     */
    async getPackagesDefinitions() {
        const response = await this.getPackagesDefinitionsRaw();
        return await response.value();
    }
    /**
     * Get package definition list by code.
     */
    async getPackagesDefinitionsByCodesRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/definitionsByCodes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetPackageDefinitionByCodesRequestFromJSONTyped(requestParameters.apiGetPackageDefinitionByCodesRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiPackageModelDefinitionFromJSON));
    }
    /**
     * Get package definition list by code.
     */
    async getPackagesDefinitionsByCodes(apiGetPackageDefinitionByCodesRequest) {
        const response = await this.getPackagesDefinitionsByCodesRaw({ apiGetPackageDefinitionByCodesRequest: apiGetPackageDefinitionByCodesRequest });
        return await response.value();
    }
    /**
     * Get password complexity information
     */
    async getPasswordComplexityRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/authentication/passwordComplexity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetPasswordComplexityResponseFromJSON(jsonValue));
    }
    /**
     * Get password complexity information
     */
    async getPasswordComplexity() {
        const response = await this.getPasswordComplexityRaw();
        return await response.value();
    }
    /**
     * Pax/Room Assignments
     */
    async getPaxRoomAssignmentsRaw(requestParameters) {
        if (requestParameters.apiGetPaxRoomAssignmentRequest === null || requestParameters.apiGetPaxRoomAssignmentRequest === undefined) {
            throw new RequiredError('apiGetPaxRoomAssignmentRequest', 'Required parameter requestParameters.apiGetPaxRoomAssignmentRequest was null or undefined when calling getPaxRoomAssignments.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/bestprice/paxRoomAssignments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetPaxRoomAssignmentRequestFromJSONTyped(requestParameters.apiGetPaxRoomAssignmentRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetPaxRoomAssignmentResponseFromJSON(jsonValue));
    }
    /**
     * Pax/Room Assignments
     */
    async getPaxRoomAssignments(apiGetPaxRoomAssignmentRequest) {
        const response = await this.getPaxRoomAssignmentsRaw({ apiGetPaxRoomAssignmentRequest: apiGetPaxRoomAssignmentRequest });
        return await response.value();
    }
    /**
     * Get payment options
     */
    async getPaymentOptionsRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling getPaymentOptions.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/paymentOptions/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetPaymentOptionsResponseFromJSON(jsonValue));
    }
    /**
     * Get payment options
     */
    async getPaymentOptions(bookingId) {
        const response = await this.getPaymentOptionsRaw({ bookingId: bookingId });
        return await response.value();
    }
    /**
     * Gets a list of products related to the product code
     */
    async getProductsListRaw(requestParameters) {
        if (requestParameters.apiProductsCacheRequest === null || requestParameters.apiProductsCacheRequest === undefined) {
            throw new RequiredError('apiProductsCacheRequest', 'Required parameter requestParameters.apiProductsCacheRequest was null or undefined when calling getProductsList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/products/productsCache`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiProductsCacheRequestFromJSONTyped(requestParameters.apiProductsCacheRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiProductsCacheResponseFromJSON));
    }
    /**
     * Gets a list of products related to the product code
     */
    async getProductsList(apiProductsCacheRequest) {
        const response = await this.getProductsListRaw({ apiProductsCacheRequest: apiProductsCacheRequest });
        return await response.value();
    }
    /**
     * get recommendations
     */
    async getRecommendationsRaw(requestParameters) {
        if (requestParameters.apiGetRecommendationsRequest === null || requestParameters.apiGetRecommendationsRequest === undefined) {
            throw new RequiredError('apiGetRecommendationsRequest', 'Required parameter requestParameters.apiGetRecommendationsRequest was null or undefined when calling getRecommendations.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/travelTailor/getRecommendations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetRecommendationsRequestFromJSONTyped(requestParameters.apiGetRecommendationsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetRecommendationsResponseFromJSON(jsonValue));
    }
    /**
     * get recommendations
     */
    async getRecommendations(apiGetRecommendationsRequest) {
        const response = await this.getRecommendationsRaw({ apiGetRecommendationsRequest: apiGetRecommendationsRequest });
        return await response.value();
    }
    /**
     * Search for rental cars
     */
    async getRentalCarListRaw(requestParameters) {
        if (requestParameters.apiGetRentalCarListRequest === null || requestParameters.apiGetRentalCarListRequest === undefined) {
            throw new RequiredError('apiGetRentalCarListRequest', 'Required parameter requestParameters.apiGetRentalCarListRequest was null or undefined when calling getRentalCarList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/rentalCar/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetRentalCarListRequestFromJSONTyped(requestParameters.apiGetRentalCarListRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetRentalCarListResponseFromJSON(jsonValue));
    }
    /**
     * Search for rental cars
     */
    async getRentalCarList(apiGetRentalCarListRequest) {
        const response = await this.getRentalCarListRaw({ apiGetRentalCarListRequest: apiGetRentalCarListRequest });
        return await response.value();
    }
    /**
     * Get rental car offices data from Pacific.
     */
    async getRentalCarOfficesRaw(requestParameters) {
        if (requestParameters.apiRentalCarOfficesRequest === null || requestParameters.apiRentalCarOfficesRequest === undefined) {
            throw new RequiredError('apiRentalCarOfficesRequest', 'Required parameter requestParameters.apiRentalCarOfficesRequest was null or undefined when calling getRentalCarOffices.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getRentalCarOffices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiRentalCarOfficesRequestFromJSONTyped(requestParameters.apiRentalCarOfficesRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiRentalCarOfficesResponseFromJSON(jsonValue));
    }
    /**
     * Get rental car offices data from Pacific.
     */
    async getRentalCarOffices(apiRentalCarOfficesRequest) {
        const response = await this.getRentalCarOfficesRaw({ apiRentalCarOfficesRequest: apiRentalCarOfficesRequest });
        return await response.value();
    }
    /**
     * Get rental cars Terms & Conditions
     */
    async getRentalCarTermsAndConditionsRaw(requestParameters) {
        if (requestParameters.apiGetRentalCarTermsAndConditionsRequest === null || requestParameters.apiGetRentalCarTermsAndConditionsRequest === undefined) {
            throw new RequiredError('apiGetRentalCarTermsAndConditionsRequest', 'Required parameter requestParameters.apiGetRentalCarTermsAndConditionsRequest was null or undefined when calling getRentalCarTermsAndConditions.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/rentalCar/terms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetRentalCarTermsAndConditionsRequestFromJSONTyped(requestParameters.apiGetRentalCarTermsAndConditionsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetRentalCarTermsAndConditionsResponseFromJSON(jsonValue));
    }
    /**
     * Get rental cars Terms & Conditions
     */
    async getRentalCarTermsAndConditions(apiGetRentalCarTermsAndConditionsRequest) {
        const response = await this.getRentalCarTermsAndConditionsRaw({ apiGetRentalCarTermsAndConditionsRequest: apiGetRentalCarTermsAndConditionsRequest });
        return await response.value();
    }
    /**
     * Details for a rental car
     */
    async getRentalDetailsRaw(requestParameters) {
        if (requestParameters.apiGetRentalCarDetailsRequest === null || requestParameters.apiGetRentalCarDetailsRequest === undefined) {
            throw new RequiredError('apiGetRentalCarDetailsRequest', 'Required parameter requestParameters.apiGetRentalCarDetailsRequest was null or undefined when calling getRentalDetails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/rentalCar/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetRentalCarDetailsRequestFromJSONTyped(requestParameters.apiGetRentalCarDetailsRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetRentalCarDetailsResponseFromJSON(jsonValue));
    }
    /**
     * Details for a rental car
     */
    async getRentalDetails(apiGetRentalCarDetailsRequest) {
        const response = await this.getRentalDetailsRaw({ apiGetRentalCarDetailsRequest: apiGetRentalCarDetailsRequest });
        return await response.value();
    }
    /**
     * Rental car stations by geo unit
     */
    async getRentalStationsRaw(requestParameters) {
        if (requestParameters.apiGetRentalCarStationsRequest === null || requestParameters.apiGetRentalCarStationsRequest === undefined) {
            throw new RequiredError('apiGetRentalCarStationsRequest', 'Required parameter requestParameters.apiGetRentalCarStationsRequest was null or undefined when calling getRentalStations.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getRentalCarStations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetRentalCarStationsRequestFromJSONTyped(requestParameters.apiGetRentalCarStationsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetRentalCarStationsResponseFromJSON(jsonValue));
    }
    /**
     * Rental car stations by geo unit
     */
    async getRentalStations(apiGetRentalCarStationsRequest) {
        const response = await this.getRentalStationsRaw({ apiGetRentalCarStationsRequest: apiGetRentalCarStationsRequest });
        return await response.value();
    }
    /**
     * Get list of all defined seasons
     */
    async getSeasonsRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/seasons/getAll`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiSeasonFromJSON));
    }
    /**
     * Get list of all defined seasons
     */
    async getSeasons() {
        const response = await this.getSeasonsRaw();
        return await response.value();
    }
    /**
     * Get seatmap
     */
    async getSeatMapRaw(requestParameters) {
        if (requestParameters.apiGetSeatMapRequest === null || requestParameters.apiGetSeatMapRequest === undefined) {
            throw new RequiredError('apiGetSeatMapRequest', 'Required parameter requestParameters.apiGetSeatMapRequest was null or undefined when calling getSeatMap.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/seatmap/getSeatMap`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetSeatMapRequestFromJSONTyped(requestParameters.apiGetSeatMapRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetSeatMapResponseFromJSON(jsonValue));
    }
    /**
     * Get seatmap
     */
    async getSeatMap(apiGetSeatMapRequest) {
        const response = await this.getSeatMapRaw({ apiGetSeatMapRequest: apiGetSeatMapRequest });
        return await response.value();
    }
    /**
     * Get multiple seatmaps
     */
    async getSeatMapsRaw(requestParameters) {
        if (requestParameters.apiGetSeatMapsRequest === null || requestParameters.apiGetSeatMapsRequest === undefined) {
            throw new RequiredError('apiGetSeatMapsRequest', 'Required parameter requestParameters.apiGetSeatMapsRequest was null or undefined when calling getSeatMaps.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/seatmap/getSeatMaps`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetSeatMapsRequestFromJSONTyped(requestParameters.apiGetSeatMapsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetSeatMapsResponseFromJSON(jsonValue));
    }
    /**
     * Get multiple seatmaps
     */
    async getSeatMaps(apiGetSeatMapsRequest) {
        const response = await this.getSeatMapsRaw({ apiGetSeatMapsRequest: apiGetSeatMapsRequest });
        return await response.value();
    }
    /**
     * Get service description data from Pacific.
     */
    async getServiceDescriptionDataRaw(requestParameters) {
        if (requestParameters.apiGetDescriptionDataRequest === null || requestParameters.apiGetDescriptionDataRequest === undefined) {
            throw new RequiredError('apiGetDescriptionDataRequest', 'Required parameter requestParameters.apiGetDescriptionDataRequest was null or undefined when calling getServiceDescriptionData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/descriptionData/service`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetDescriptionDataRequestFromJSONTyped(requestParameters.apiGetDescriptionDataRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiDescriptionDataFromJSON));
    }
    /**
     * Get service description data from Pacific.
     */
    async getServiceDescriptionData(apiGetDescriptionDataRequest) {
        const response = await this.getServiceDescriptionDataRaw({ apiGetDescriptionDataRequest: apiGetDescriptionDataRequest });
        return await response.value();
    }
    /**
     * Get service unit description data from Pacific.
     */
    async getServiceUnitDescriptionDataRaw(requestParameters) {
        if (requestParameters.apiGetDescriptionDataRequest === null || requestParameters.apiGetDescriptionDataRequest === undefined) {
            throw new RequiredError('apiGetDescriptionDataRequest', 'Required parameter requestParameters.apiGetDescriptionDataRequest was null or undefined when calling getServiceUnitDescriptionData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/descriptionData/serviceUnit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetDescriptionDataRequestFromJSONTyped(requestParameters.apiGetDescriptionDataRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiDescriptionDataFromJSON));
    }
    /**
     * Get service unit description data from Pacific.
     */
    async getServiceUnitDescriptionData(apiGetDescriptionDataRequest) {
        const response = await this.getServiceUnitDescriptionDataRaw({ apiGetDescriptionDataRequest: apiGetDescriptionDataRequest });
        return await response.value();
    }
    /**
     * Gets special requests for services
     */
    async getSpecialRequestsRaw(requestParameters) {
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getSpecialRequests.');
        }
        const queryParameters = {};
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        if (requestParameters.serviceId !== undefined) {
            queryParameters['serviceId'] = requestParameters.serviceId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getSpecialRequests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiSpecialRequestFromJSON));
    }
    /**
     * Gets special requests for services
     */
    async getSpecialRequests(type, serviceId) {
        const response = await this.getSpecialRequestsRaw({ type: type, serviceId: serviceId });
        return await response.value();
    }
    /**
     * Gets restrictions for special requests
     */
    async getSpecialRequestsRestrictionsRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        if (requestParameters.serviceId !== undefined) {
            queryParameters['serviceId'] = requestParameters.serviceId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getSpecialRequestsRestrictions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiSpecialRequestsRestrictionFromJSON));
    }
    /**
     * Gets restrictions for special requests
     */
    async getSpecialRequestsRestrictions(type, serviceId) {
        const response = await this.getSpecialRequestsRestrictionsRaw({ type: type, serviceId: serviceId });
        return await response.value();
    }
    /**
     * get Theme node from CMS
     */
    async getThemeRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/content/getTheme`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiThemeResponseFromJSON(jsonValue));
    }
    /**
     * get Theme node from CMS
     */
    async getTheme() {
        const response = await this.getThemeRaw();
        return await response.value();
    }
    /**
     * Gets voucher as wallet
     */
    async getTicketInWalletRaw(requestParameters) {
        if (requestParameters.bookingNumber === null || requestParameters.bookingNumber === undefined) {
            throw new RequiredError('bookingNumber', 'Required parameter requestParameters.bookingNumber was null or undefined when calling getTicketInWallet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/getTicketInWallet/{bookingNumber}`.replace(`{${"bookingNumber"}}`, encodeURIComponent(String(requestParameters.bookingNumber))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiTicketResponseFromJSON));
    }
    /**
     * Gets voucher as wallet
     */
    async getTicketInWallet(bookingNumber) {
        const response = await this.getTicketInWalletRaw({ bookingNumber: bookingNumber });
        return await response.value();
    }
    /**
     * Details for a transfer
     */
    async getTransferDetailsRaw(requestParameters) {
        if (requestParameters.apiGetTransferDetailsRequest === null || requestParameters.apiGetTransferDetailsRequest === undefined) {
            throw new RequiredError('apiGetTransferDetailsRequest', 'Required parameter requestParameters.apiGetTransferDetailsRequest was null or undefined when calling getTransferDetails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/transfer/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetTransferDetailsRequestFromJSONTyped(requestParameters.apiGetTransferDetailsRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetTransferDetailsResponseFromJSON(jsonValue));
    }
    /**
     * Details for a transfer
     */
    async getTransferDetails(apiGetTransferDetailsRequest) {
        const response = await this.getTransferDetailsRaw({ apiGetTransferDetailsRequest: apiGetTransferDetailsRequest });
        return await response.value();
    }
    /**
     * Search for transfers
     */
    async getTransferListRaw(requestParameters) {
        if (requestParameters.apiGetTransferListRequest === null || requestParameters.apiGetTransferListRequest === undefined) {
            throw new RequiredError('apiGetTransferListRequest', 'Required parameter requestParameters.apiGetTransferListRequest was null or undefined when calling getTransferList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/transfer/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetTransferListRequestFromJSONTyped(requestParameters.apiGetTransferListRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetTransferListResponseFromJSON(jsonValue));
    }
    /**
     * Search for transfers
     */
    async getTransferList(apiGetTransferListRequest) {
        const response = await this.getTransferListRaw({ apiGetTransferListRequest: apiGetTransferListRequest });
        return await response.value();
    }
    /**
     * get travel destination advices node from CMS
     */
    async getTravelAdvicesRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/getTravelAdvices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiTravelAdviceResponseFromJSON(jsonValue));
    }
    /**
     * get travel destination advices node from CMS
     */
    async getTravelAdvices() {
        const response = await this.getTravelAdvicesRaw();
        return await response.value();
    }
    /**
     * get upsell
     */
    async getUpsellRaw(requestParameters) {
        if (requestParameters.apiGetRecommendationsRequest === null || requestParameters.apiGetRecommendationsRequest === undefined) {
            throw new RequiredError('apiGetRecommendationsRequest', 'Required parameter requestParameters.apiGetRecommendationsRequest was null or undefined when calling getUpsell.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/travelTailor/getUpsell`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetRecommendationsRequestFromJSONTyped(requestParameters.apiGetRecommendationsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetRecommendationsResponseFromJSON(jsonValue));
    }
    /**
     * get upsell
     */
    async getUpsell(apiGetRecommendationsRequest) {
        const response = await this.getUpsellRaw({ apiGetRecommendationsRequest: apiGetRecommendationsRequest });
        return await response.value();
    }
    /**
     * retrieve voucher details
     */
    async getVoucherDetailsRaw(requestParameters) {
        if (requestParameters.apiGetExtraServiceRequest === null || requestParameters.apiGetExtraServiceRequest === undefined) {
            throw new RequiredError('apiGetExtraServiceRequest', 'Required parameter requestParameters.apiGetExtraServiceRequest was null or undefined when calling getVoucherDetails.');
        }
        const queryParameters = {};
        if (requestParameters.noCache !== undefined) {
            queryParameters['noCache'] = requestParameters.noCache;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/voucher/getVoucherDetails`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetExtraServiceRequestFromJSONTyped(requestParameters.apiGetExtraServiceRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiVoucherFromJSON(jsonValue));
    }
    /**
     * retrieve voucher details
     */
    async getVoucherDetails(apiGetExtraServiceRequest, noCache) {
        const response = await this.getVoucherDetailsRaw({ apiGetExtraServiceRequest: apiGetExtraServiceRequest, noCache: noCache });
        return await response.value();
    }
    /**
     * Get promotion voucher value
     */
    async getVoucherValueRaw(requestParameters) {
        if (requestParameters.apiGetVoucherValueRequest === null || requestParameters.apiGetVoucherValueRequest === undefined) {
            throw new RequiredError('apiGetVoucherValueRequest', 'Required parameter requestParameters.apiGetVoucherValueRequest was null or undefined when calling getVoucherValue.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/getVoucherValue`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetVoucherValueRequestFromJSONTyped(requestParameters.apiGetVoucherValueRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetVoucherValueResponseFromJSON(jsonValue));
    }
    /**
     * Get promotion voucher value
     */
    async getVoucherValue(apiGetVoucherValueRequest) {
        const response = await this.getVoucherValueRaw({ apiGetVoucherValueRequest: apiGetVoucherValueRequest });
        return await response.value();
    }
    /**
     * retrieve vouchers
     */
    async getVouchersRaw(requestParameters) {
        if (requestParameters.apiGetExtraServiceListRequest === null || requestParameters.apiGetExtraServiceListRequest === undefined) {
            throw new RequiredError('apiGetExtraServiceListRequest', 'Required parameter requestParameters.apiGetExtraServiceListRequest was null or undefined when calling getVouchers.');
        }
        const queryParameters = {};
        if (requestParameters.noCache !== undefined) {
            queryParameters['noCache'] = requestParameters.noCache;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/voucher/getVouchers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetExtraServiceListRequestFromJSONTyped(requestParameters.apiGetExtraServiceListRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiVouchersResponseFromJSON(jsonValue));
    }
    /**
     * retrieve vouchers
     */
    async getVouchers(apiGetExtraServiceListRequest, noCache) {
        const response = await this.getVouchersRaw({ apiGetExtraServiceListRequest: apiGetExtraServiceListRequest, noCache: noCache });
        return await response.value();
    }
    /**
     * init a clean booking
     */
    async initBookingRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/init`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * init a clean booking
     */
    async initBooking() {
        const response = await this.initBookingRaw();
        return await response.value();
    }
    /**
     */
    async initFlightTripBookingRaw(requestParameters) {
        if (requestParameters.packageId === null || requestParameters.packageId === undefined) {
            throw new RequiredError('packageId', 'Required parameter requestParameters.packageId was null or undefined when calling initFlightTripBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/flighttrip/init/{packageId}`.replace(`{${"packageId"}}`, encodeURIComponent(String(requestParameters.packageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetFlightTripBookingResponseFromJSON(jsonValue));
    }
    /**
     */
    async initFlightTripBooking(packageId) {
        const response = await this.initFlightTripBookingRaw({ packageId: packageId });
        return await response.value();
    }
    /**
     */
    async itemsRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/items`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiBaseModelFromJSONTyped(requestParameters.apiBaseModel, false),
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiBaseModelFromJSON));
    }
    /**
     */
    async items(apiBaseModel) {
        const response = await this.itemsRaw({ apiBaseModel: apiBaseModel });
        return await response.value();
    }
    /**
     * Load package cart
     */
    async loadRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling load.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     * Load package cart
     */
    async load(packageCartId) {
        const response = await this.loadRaw({ packageCartId: packageCartId });
        return await response.value();
    }
    /**
     * Load workflow step
     */
    async loadStepRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/loadStep`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiWorkflowStepRequestFromJSONTyped(requestParameters.apiWorkflowStepRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiWorkflowStepResponseFromJSON(jsonValue));
    }
    /**
     * Load workflow step
     */
    async loadStep(apiWorkflowStepRequest) {
        const response = await this.loadStepRaw({ apiWorkflowStepRequest: apiWorkflowStepRequest });
        return await response.value();
    }
    /**
     * newsletter signup
     */
    async newsletterSignupRaw(requestParameters) {
        if (requestParameters.apiSignupRequest === null || requestParameters.apiSignupRequest === undefined) {
            throw new RequiredError('apiSignupRequest', 'Required parameter requestParameters.apiSignupRequest was null or undefined when calling newsletterSignup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/newsletter/signup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiSignupRequestFromJSONTyped(requestParameters.apiSignupRequest),
        });
        return new TextApiResponse(response);
    }
    /**
     * newsletter signup
     */
    async newsletterSignup(apiSignupRequest) {
        const response = await this.newsletterSignupRaw({ apiSignupRequest: apiSignupRequest });
        return await response.value();
    }
    /**
     * Signup for newsletter subscription
     */
    async newsletterSubscriptionRaw(requestParameters) {
        if (requestParameters.apiNewsletterSubscriptionRequest === null || requestParameters.apiNewsletterSubscriptionRequest === undefined) {
            throw new RequiredError('apiNewsletterSubscriptionRequest', 'Required parameter requestParameters.apiNewsletterSubscriptionRequest was null or undefined when calling newsletterSubscription.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/newsletterSubscription`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiNewsletterSubscriptionRequestFromJSONTyped(requestParameters.apiNewsletterSubscriptionRequest),
        });
        return new VoidApiResponse(response);
    }
    /**
     * Signup for newsletter subscription
     */
    async newsletterSubscription(apiNewsletterSubscriptionRequest) {
        await this.newsletterSubscriptionRaw({ apiNewsletterSubscriptionRequest: apiNewsletterSubscriptionRequest });
    }
    /**
     * prepare booking for payment. creates temp booking and creates payment redirect urls
     */
    async preparePaymentRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling preparePayment.');
        }
        if (requestParameters.apiPreparePaymentRequest === null || requestParameters.apiPreparePaymentRequest === undefined) {
            throw new RequiredError('apiPreparePaymentRequest', 'Required parameter requestParameters.apiPreparePaymentRequest was null or undefined when calling preparePayment.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/preparePayment/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiPreparePaymentRequestFromJSONTyped(requestParameters.apiPreparePaymentRequest),
        });
        return new TextApiResponse(response);
    }
    /**
     * prepare booking for payment. creates temp booking and creates payment redirect urls
     */
    async preparePayment(bookingId, apiPreparePaymentRequest) {
        const response = await this.preparePaymentRaw({ bookingId: bookingId, apiPreparePaymentRequest: apiPreparePaymentRequest });
        return await response.value();
    }
    /**
     * prepare booking of the voucher for payment. creates temp booking and creates payment redirect urls
     */
    async prepareVoucherPaymentRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling prepareVoucherPayment.');
        }
        if (requestParameters.apiPreparePaymentRequest === null || requestParameters.apiPreparePaymentRequest === undefined) {
            throw new RequiredError('apiPreparePaymentRequest', 'Required parameter requestParameters.apiPreparePaymentRequest was null or undefined when calling prepareVoucherPayment.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/voucher/preparePayment/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiPreparePaymentRequestFromJSONTyped(requestParameters.apiPreparePaymentRequest),
        });
        return new TextApiResponse(response);
    }
    /**
     * prepare booking of the voucher for payment. creates temp booking and creates payment redirect urls
     */
    async prepareVoucherPayment(bookingId, apiPreparePaymentRequest) {
        const response = await this.prepareVoucherPaymentRaw({ bookingId: bookingId, apiPreparePaymentRequest: apiPreparePaymentRequest });
        return await response.value();
    }
    /**
     * Get Product Reviews
     */
    async productReviewsRaw(requestParameters) {
        if (requestParameters.ids === null || requestParameters.ids === undefined) {
            throw new RequiredError('ids', 'Required parameter requestParameters.ids was null or undefined when calling productReviews.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/productReviews/{ids}`.replace(`{${"ids"}}`, encodeURIComponent(String(requestParameters.ids))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiProductWithReviewsFromJSON));
    }
    /**
     * Get Product Reviews
     */
    async productReviews(ids) {
        const response = await this.productReviewsRaw({ ids: ids });
        return await response.value();
    }
    /**
     * refreshs login token
     */
    async refreshTokenRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/login/refresh`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new TextApiResponse(response);
    }
    /**
     * refreshs login token
     */
    async refreshToken() {
        const response = await this.refreshTokenRaw();
        return await response.value();
    }
    /**
     * reinit a booking
     */
    async reinitBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling reinitBooking.');
        }
        const queryParameters = {};
        if (requestParameters.bookingId !== undefined) {
            queryParameters['bookingId'] = requestParameters.bookingId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/reinit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * reinit a booking
     */
    async reinitBooking(bookingId) {
        const response = await this.reinitBookingRaw({ bookingId: bookingId });
        return await response.value();
    }
    /**
     * Remove package cart
     */
    async removeRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling remove.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/remove/{packageCartId}`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new VoidApiResponse(response);
    }
    /**
     * Remove package cart
     */
    async remove(packageCartId) {
        await this.removeRaw({ packageCartId: packageCartId });
    }
    /**
     * remove a booking
     */
    async removeBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling removeBooking.');
        }
        const queryParameters = {};
        if (requestParameters.noCache !== undefined) {
            queryParameters['noCache'] = requestParameters.noCache;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/remove/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new VoidApiResponse(response);
    }
    /**
     * remove a booking
     */
    async removeBooking(bookingId, noCache) {
        await this.removeBookingRaw({ bookingId: bookingId, noCache: noCache });
    }
    /**
     */
    async removeItemRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling removeItem.');
        }
        if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
            throw new RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling removeItem.');
        }
        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
            throw new RequiredError('itemId', 'Required parameter requestParameters.itemId was null or undefined when calling removeItem.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/component/{componentId}/remove/{itemId}`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters.itemId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     */
    async removeItem(packageCartId, componentId, itemId) {
        const response = await this.removeItemRaw({ packageCartId: packageCartId, componentId: componentId, itemId: itemId });
        return await response.value();
    }
    /**
     */
    async removeItemsRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling removeItems.');
        }
        if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
            throw new RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling removeItems.');
        }
        if (requestParameters.apiRemovePackageItemsRequest === null || requestParameters.apiRemovePackageItemsRequest === undefined) {
            throw new RequiredError('apiRemovePackageItemsRequest', 'Required parameter requestParameters.apiRemovePackageItemsRequest was null or undefined when calling removeItems.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/component/{componentId}/removeItems`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiRemovePackageItemsRequestFromJSONTyped(requestParameters.apiRemovePackageItemsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     */
    async removeItems(packageCartId, componentId, apiRemovePackageItemsRequest) {
        const response = await this.removeItemsRaw({ packageCartId: packageCartId, componentId: componentId, apiRemovePackageItemsRequest: apiRemovePackageItemsRequest });
        return await response.value();
    }
    /**
     * remove traveler
     */
    async removeTravelerRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling removeTraveler.');
        }
        if (requestParameters.attempt === null || requestParameters.attempt === undefined) {
            throw new RequiredError('attempt', 'Required parameter requestParameters.attempt was null or undefined when calling removeTraveler.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/traveler/{attempt}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))).replace(`{${"attempt"}}`, encodeURIComponent(String(requestParameters.attempt))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: ApiTravelerFromJSONTyped(requestParameters.apiTraveler),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * remove traveler
     */
    async removeTraveler(bookingId, attempt, apiTraveler) {
        const response = await this.removeTravelerRaw({ bookingId: bookingId, attempt: attempt, apiTraveler: apiTraveler });
        return await response.value();
    }
    /**
     */
    async replaceItemRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling replaceItem.');
        }
        if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
            throw new RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling replaceItem.');
        }
        if (requestParameters.addItemId === null || requestParameters.addItemId === undefined) {
            throw new RequiredError('addItemId', 'Required parameter requestParameters.addItemId was null or undefined when calling replaceItem.');
        }
        if (requestParameters.removeItemId === null || requestParameters.removeItemId === undefined) {
            throw new RequiredError('removeItemId', 'Required parameter requestParameters.removeItemId was null or undefined when calling replaceItem.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/component/{componentId}/replace/{addItemId}/{removeItemId}`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))).replace(`{${"addItemId"}}`, encodeURIComponent(String(requestParameters.addItemId))).replace(`{${"removeItemId"}}`, encodeURIComponent(String(requestParameters.removeItemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     */
    async replaceItem(packageCartId, componentId, addItemId, removeItemId) {
        const response = await this.replaceItemRaw({ packageCartId: packageCartId, componentId: componentId, addItemId: addItemId, removeItemId: removeItemId });
        return await response.value();
    }
    /**
     * resets agency password
     */
    async resetPasswordRaw(requestParameters) {
        if (requestParameters.apiResetAgencyPasswordRequest === null || requestParameters.apiResetAgencyPasswordRequest === undefined) {
            throw new RequiredError('apiResetAgencyPasswordRequest', 'Required parameter requestParameters.apiResetAgencyPasswordRequest was null or undefined when calling resetPassword.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/authentication/resetAgencyPassword`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiResetAgencyPasswordRequestFromJSONTyped(requestParameters.apiResetAgencyPasswordRequest),
        });
        return new VoidApiResponse(response);
    }
    /**
     * resets agency password
     */
    async resetPassword(apiResetAgencyPasswordRequest) {
        await this.resetPasswordRaw({ apiResetAgencyPasswordRequest: apiResetAgencyPasswordRequest });
    }
    /**
     * Get business partner as traveler.
     */
    async retrieveBusinessPartnerAsTravelerRaw(requestParameters) {
        if (requestParameters.apiGetBusinessPartnerRequest === null || requestParameters.apiGetBusinessPartnerRequest === undefined) {
            throw new RequiredError('apiGetBusinessPartnerRequest', 'Required parameter requestParameters.apiGetBusinessPartnerRequest was null or undefined when calling retrieveBusinessPartnerAsTraveler.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/businesspartner/retrieveTraveler`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetBusinessPartnerRequestFromJSONTyped(requestParameters.apiGetBusinessPartnerRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiTravelerFromJSON(jsonValue));
    }
    /**
     * Get business partner as traveler.
     */
    async retrieveBusinessPartnerAsTraveler(apiGetBusinessPartnerRequest) {
        const response = await this.retrieveBusinessPartnerAsTravelerRaw({ apiGetBusinessPartnerRequest: apiGetBusinessPartnerRequest });
        return await response.value();
    }
    /**
     * retrieve a package
     */
    async retrievePackageRaw(requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling retrievePackage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageModelFromJSON(jsonValue));
    }
    /**
     * retrieve a package
     */
    async retrievePackage(id) {
        const response = await this.retrievePackageRaw({ id: id });
        return await response.value();
    }
    /**
     * Save workflow step
     */
    async saveStepRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/saveStep`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiWorkflowStepRequestFromJSONTyped(requestParameters.apiWorkflowStepRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiWorkflowStepResponseFromJSON(jsonValue));
    }
    /**
     * Save workflow step
     */
    async saveStep(apiWorkflowStepRequest) {
        const response = await this.saveStepRaw({ apiWorkflowStepRequest: apiWorkflowStepRequest });
        return await response.value();
    }
    /**
     * Search for best price package availability
     */
    async searchBestPricePackageAvailabilityRaw(requestParameters) {
        if (requestParameters.apiGetBestPricePackageAvailabilityRequest === null || requestParameters.apiGetBestPricePackageAvailabilityRequest === undefined) {
            throw new RequiredError('apiGetBestPricePackageAvailabilityRequest', 'Required parameter requestParameters.apiGetBestPricePackageAvailabilityRequest was null or undefined when calling searchBestPricePackageAvailability.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/bestprice/availability`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetBestPricePackageAvailabilityRequestFromJSONTyped(requestParameters.apiGetBestPricePackageAvailabilityRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetBestPricePackageAvailabilityResponseFromJSON(jsonValue));
    }
    /**
     * Search for best price package availability
     */
    async searchBestPricePackageAvailability(apiGetBestPricePackageAvailabilityRequest) {
        const response = await this.searchBestPricePackageAvailabilityRaw({ apiGetBestPricePackageAvailabilityRequest: apiGetBestPricePackageAvailabilityRequest });
        return await response.value();
    }
    /**
     * Search for best price packages
     */
    async searchBestPricePackagesRaw(requestParameters) {
        if (requestParameters.apiGetPackagesRequest === null || requestParameters.apiGetPackagesRequest === undefined) {
            throw new RequiredError('apiGetPackagesRequest', 'Required parameter requestParameters.apiGetPackagesRequest was null or undefined when calling searchBestPricePackages.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/bestprice/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetPackagesRequestFromJSONTyped(requestParameters.apiGetPackagesRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetBestPricePackagesResponseFromJSON(jsonValue));
    }
    /**
     * Search for best price packages
     */
    async searchBestPricePackages(apiGetPackagesRequest) {
        const response = await this.searchBestPricePackagesRaw({ apiGetPackagesRequest: apiGetPackagesRequest });
        return await response.value();
    }
    /**
     * retrieve a booking by token
     */
    async searchBookingByTokenRaw(requestParameters) {
        if (requestParameters.bookingToken === null || requestParameters.bookingToken === undefined) {
            throw new RequiredError('bookingToken', 'Required parameter requestParameters.bookingToken was null or undefined when calling searchBookingByToken.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/searchBookingByToken/{bookingToken}`.replace(`{${"bookingToken"}}`, encodeURIComponent(String(requestParameters.bookingToken))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * retrieve a booking by token
     */
    async searchBookingByToken(bookingToken) {
        const response = await this.searchBookingByTokenRaw({ bookingToken: bookingToken });
        return await response.value();
    }
    /**
     * retrieve a bookingpane
     */
    async searchBookingsRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/searchBookings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiBookingSearchFromJSONTyped(requestParameters.apiBookingSearch),
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiBookingPaneFromJSON));
    }
    /**
     * retrieve a bookingpane
     */
    async searchBookings(apiBookingSearch) {
        const response = await this.searchBookingsRaw({ apiBookingSearch: apiBookingSearch });
        return await response.value();
    }
    /**
     * Searches for flight departures
     */
    async searchFlightDeparturesRaw(requestParameters) {
        if (requestParameters.apiFlightDepartureRequest === null || requestParameters.apiFlightDepartureRequest === undefined) {
            throw new RequiredError('apiFlightDepartureRequest', 'Required parameter requestParameters.apiFlightDepartureRequest was null or undefined when calling searchFlightDepartures.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/flight/flightDepartures/fetch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiFlightDepartureRequestFromJSONTyped(requestParameters.apiFlightDepartureRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiFlightDepartureResponseFromJSON));
    }
    /**
     * Searches for flight departures
     */
    async searchFlightDepartures(apiFlightDepartureRequest) {
        const response = await this.searchFlightDeparturesRaw({ apiFlightDepartureRequest: apiFlightDepartureRequest });
        return await response.value();
    }
    /**
     * Search for flight trip packages
     */
    async searchFlightTripPackagesRaw(requestParameters) {
        if (requestParameters.apiGetFlightTripPackageRequest === null || requestParameters.apiGetFlightTripPackageRequest === undefined) {
            throw new RequiredError('apiGetFlightTripPackageRequest', 'Required parameter requestParameters.apiGetFlightTripPackageRequest was null or undefined when calling searchFlightTripPackages.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/flighttrip/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetFlightTripPackageRequestFromJSONTyped(requestParameters.apiGetFlightTripPackageRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetBestPricePackagesResponseFromJSON(jsonValue));
    }
    /**
     * Search for flight trip packages
     */
    async searchFlightTripPackages(apiGetFlightTripPackageRequest) {
        const response = await this.searchFlightTripPackagesRaw({ apiGetFlightTripPackageRequest: apiGetFlightTripPackageRequest });
        return await response.value();
    }
    /**
     * Geographical units the application and services are based on. Usually this data is some kind of master data and may be cached. There may be different kind of geographical unit types, like \'CITY\', \'REGION\' or \'COUNTRY\'.
     */
    async searchGeoUnitsRaw(requestParameters) {
        if (requestParameters.apiSearchGeoUnitsRequest === null || requestParameters.apiSearchGeoUnitsRequest === undefined) {
            throw new RequiredError('apiSearchGeoUnitsRequest', 'Required parameter requestParameters.apiSearchGeoUnitsRequest was null or undefined when calling searchGeoUnits.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/masterdata/searchGeoUnits`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiSearchGeoUnitsRequestFromJSONTyped(requestParameters.apiSearchGeoUnitsRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiSearchGeoUnitsResponseFromJSON(jsonValue));
    }
    /**
     * Geographical units the application and services are based on. Usually this data is some kind of master data and may be cached. There may be different kind of geographical unit types, like \'CITY\', \'REGION\' or \'COUNTRY\'.
     */
    async searchGeoUnits(apiSearchGeoUnitsRequest) {
        const response = await this.searchGeoUnitsRaw({ apiSearchGeoUnitsRequest: apiSearchGeoUnitsRequest });
        return await response.value();
    }
    /**
     * Searches for geo units
     */
    async searchGeoUnitsElasticRaw(requestParameters) {
        if (requestParameters.apiSearchGeoUnitsRequest === null || requestParameters.apiSearchGeoUnitsRequest === undefined) {
            throw new RequiredError('apiSearchGeoUnitsRequest', 'Required parameter requestParameters.apiSearchGeoUnitsRequest was null or undefined when calling searchGeoUnitsElastic.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/search/searchGeoUnits`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiSearchGeoUnitsRequestFromJSONTyped(requestParameters.apiSearchGeoUnitsRequest, false),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiSearchGeoUnitsResponseFromJSON(jsonValue));
    }
    /**
     * Searches for geo units
     */
    async searchGeoUnitsElastic(apiSearchGeoUnitsRequest) {
        const response = await this.searchGeoUnitsElasticRaw({ apiSearchGeoUnitsRequest: apiSearchGeoUnitsRequest });
        return await response.value();
    }
    /**
     * Search for packages
     */
    async searchPackagesRaw(requestParameters) {
        if (requestParameters.apiGetPackagesRequest === null || requestParameters.apiGetPackagesRequest === undefined) {
            throw new RequiredError('apiGetPackagesRequest', 'Required parameter requestParameters.apiGetPackagesRequest was null or undefined when calling searchPackages.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetPackagesRequestFromJSONTyped(requestParameters.apiGetPackagesRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetPackagesResponseFromJSON(jsonValue));
    }
    /**
     * Search for packages
     */
    async searchPackages(apiGetPackagesRequest) {
        const response = await this.searchPackagesRaw({ apiGetPackagesRequest: apiGetPackagesRequest });
        return await response.value();
    }
    /**
     * Searches for productData and geoUnits
     */
    async searchProductDataRaw(requestParameters) {
        if (requestParameters.apiSearchProductDataRequest === null || requestParameters.apiSearchProductDataRequest === undefined) {
            throw new RequiredError('apiSearchProductDataRequest', 'Required parameter requestParameters.apiSearchProductDataRequest was null or undefined when calling searchProductData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/search/searchProductData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiSearchProductDataRequestFromJSONTyped(requestParameters.apiSearchProductDataRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiSearchProductDataResponseFromJSON(jsonValue));
    }
    /**
     * Searches for productData and geoUnits
     */
    async searchProductData(apiSearchProductDataRequest) {
        const response = await this.searchProductDataRaw({ apiSearchProductDataRequest: apiSearchProductDataRequest });
        return await response.value();
    }
    /**
     * Searches for productData by code
     */
    async searchProductDataByCodeRaw(requestParameters) {
        if (requestParameters.apiSearchProductDataByCodeRequest === null || requestParameters.apiSearchProductDataByCodeRequest === undefined) {
            throw new RequiredError('apiSearchProductDataByCodeRequest', 'Required parameter requestParameters.apiSearchProductDataByCodeRequest was null or undefined when calling searchProductDataByCode.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/search/searchProductDataByCode`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiSearchProductDataByCodeRequestFromJSONTyped(requestParameters.apiSearchProductDataByCodeRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiSearchProductDataByCodeResponseFromJSON(jsonValue));
    }
    /**
     * Searches for productData by code
     */
    async searchProductDataByCode(apiSearchProductDataByCodeRequest) {
        const response = await this.searchProductDataByCodeRaw({ apiSearchProductDataByCodeRequest: apiSearchProductDataByCodeRequest });
        return await response.value();
    }
    /**
     * Products for contentsearch
     */
    async searchProductsRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/contentsearch/searchProducts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiProductsSearchResponseFromJSON(jsonValue));
    }
    /**
     * Products for contentsearch
     */
    async searchProducts() {
        const response = await this.searchProductsRaw();
        return await response.value();
    }
    /**
     * Searches for rental car stations
     */
    async searchRentalCarStationsRaw(requestParameters) {
        if (requestParameters.apiSearchRentalCarStationsRequest === null || requestParameters.apiSearchRentalCarStationsRequest === undefined) {
            throw new RequiredError('apiSearchRentalCarStationsRequest', 'Required parameter requestParameters.apiSearchRentalCarStationsRequest was null or undefined when calling searchRentalCarStations.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/search/searchRentalCarStations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiSearchRentalCarStationsRequestFromJSONTyped(requestParameters.apiSearchRentalCarStationsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiSearchRentalCarStationsResponseFromJSON(jsonValue));
    }
    /**
     * Searches for rental car stations
     */
    async searchRentalCarStations(apiSearchRentalCarStationsRequest) {
        const response = await this.searchRentalCarStationsRaw({ apiSearchRentalCarStationsRequest: apiSearchRentalCarStationsRequest });
        return await response.value();
    }
    /**
     * Searches for text input on products and countries
     */
    async searchTextRaw(requestParameters) {
        if (requestParameters.apiTextSearchRequest === null || requestParameters.apiTextSearchRequest === undefined) {
            throw new RequiredError('apiTextSearchRequest', 'Required parameter requestParameters.apiTextSearchRequest was null or undefined when calling searchText.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/contentsearch/searchText`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiTextSearchRequestFromJSONTyped(requestParameters.apiTextSearchRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiTextSearchResponseFromJSON(jsonValue));
    }
    /**
     * Searches for text input on products and countries
     */
    async searchText(apiTextSearchRequest) {
        const response = await this.searchTextRaw({ apiTextSearchRequest: apiTextSearchRequest });
        return await response.value();
    }
    /**
     * Searches for possible travel start dates
     */
    async searchTravelStartDatesRaw(requestParameters) {
        if (requestParameters.apiFlightTravelStartDateRequest === null || requestParameters.apiFlightTravelStartDateRequest === undefined) {
            throw new RequiredError('apiFlightTravelStartDateRequest', 'Required parameter requestParameters.apiFlightTravelStartDateRequest was null or undefined when calling searchTravelStartDates.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/flight/travelStartDates/fetch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiFlightTravelStartDateRequestFromJSONTyped(requestParameters.apiFlightTravelStartDateRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiFlightTravelStartDateResponseFromJSON(jsonValue));
    }
    /**
     * Searches for possible travel start dates
     */
    async searchTravelStartDates(apiFlightTravelStartDateRequest) {
        const response = await this.searchTravelStartDatesRaw({ apiFlightTravelStartDateRequest: apiFlightTravelStartDateRequest });
        return await response.value();
    }
    /**
     */
    async selectItemsRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling selectItems.');
        }
        if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
            throw new RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling selectItems.');
        }
        if (requestParameters.apiSelectPackageItemsRequest === null || requestParameters.apiSelectPackageItemsRequest === undefined) {
            throw new RequiredError('apiSelectPackageItemsRequest', 'Required parameter requestParameters.apiSelectPackageItemsRequest was null or undefined when calling selectItems.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/component/{componentId}/selectItems`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiSelectPackageItemsRequestFromJSONTyped(requestParameters.apiSelectPackageItemsRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     */
    async selectItems(packageCartId, componentId, apiSelectPackageItemsRequest) {
        const response = await this.selectItemsRaw({ packageCartId: packageCartId, componentId: componentId, apiSelectPackageItemsRequest: apiSelectPackageItemsRequest });
        return await response.value();
    }
    /**
     * Sends booking list to customer email address
     */
    async sendBookingListToCustomerRaw(requestParameters) {
        if (requestParameters.apiSendBookingListRequest === null || requestParameters.apiSendBookingListRequest === undefined) {
            throw new RequiredError('apiSendBookingListRequest', 'Required parameter requestParameters.apiSendBookingListRequest was null or undefined when calling sendBookingListToCustomer.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/sendBookingListToCustomer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiSendBookingListRequestFromJSONTyped(requestParameters.apiSendBookingListRequest),
        });
        return new VoidApiResponse(response);
    }
    /**
     * Sends booking list to customer email address
     */
    async sendBookingListToCustomer(apiSendBookingListRequest) {
        await this.sendBookingListToCustomerRaw({ apiSendBookingListRequest: apiSendBookingListRequest });
    }
    /**
     * send group request
     */
    async sendCancelRequestRaw(requestParameters) {
        if (requestParameters.apiCancelRequest === null || requestParameters.apiCancelRequest === undefined) {
            throw new RequiredError('apiCancelRequest', 'Required parameter requestParameters.apiCancelRequest was null or undefined when calling sendCancelRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/sendCancelRequest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiCancelRequestFromJSONTyped(requestParameters.apiCancelRequest),
        });
        return new VoidApiResponse(response);
    }
    /**
     * send group request
     */
    async sendCancelRequest(apiCancelRequest) {
        await this.sendCancelRequestRaw({ apiCancelRequest: apiCancelRequest });
    }
    /**
     * send group request
     */
    async sendGroupRequestRaw(requestParameters) {
        if (requestParameters.apiGroupRequest === null || requestParameters.apiGroupRequest === undefined) {
            throw new RequiredError('apiGroupRequest', 'Required parameter requestParameters.apiGroupRequest was null or undefined when calling sendGroupRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/groups/sendGroupRequest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGroupRequestFromJSONTyped(requestParameters.apiGroupRequest),
        });
        return new VoidApiResponse(response);
    }
    /**
     * send group request
     */
    async sendGroupRequest(apiGroupRequest) {
        await this.sendGroupRequestRaw({ apiGroupRequest: apiGroupRequest });
    }
    /**
     * send message per mail
     */
    async sendMessageRaw(requestParameters) {
        if (requestParameters.apiSendEmailMessageRequest === null || requestParameters.apiSendEmailMessageRequest === undefined) {
            throw new RequiredError('apiSendEmailMessageRequest', 'Required parameter requestParameters.apiSendEmailMessageRequest was null or undefined when calling sendMessage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/email/sendMessage`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiSendEmailMessageRequestFromJSONTyped(requestParameters.apiSendEmailMessageRequest),
        });
        return new VoidApiResponse(response);
    }
    /**
     * send message per mail
     */
    async sendMessage(apiSendEmailMessageRequest) {
        await this.sendMessageRaw({ apiSendEmailMessageRequest: apiSendEmailMessageRequest });
    }
    /**
     * send token for booking to the TOP
     */
    async sendTokenForBookingRaw(requestParameters) {
        if (requestParameters.apiBookingLoginRequest === null || requestParameters.apiBookingLoginRequest === undefined) {
            throw new RequiredError('apiBookingLoginRequest', 'Required parameter requestParameters.apiBookingLoginRequest was null or undefined when calling sendTokenForBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/sendTokenForBooking`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiBookingLoginRequestFromJSONTyped(requestParameters.apiBookingLoginRequest),
        });
        return new VoidApiResponse(response);
    }
    /**
     * send token for booking to the TOP
     */
    async sendTokenForBooking(apiBookingLoginRequest) {
        await this.sendTokenForBookingRaw({ apiBookingLoginRequest: apiBookingLoginRequest });
    }
    /**
     * Sets booking associated block chain wallet data.
     */
    async setBlockchainWalletRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling setBlockchainWallet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/setBlockchainWallet/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiBlockchainWalletFromJSONTyped(requestParameters.apiBlockchainWallet),
        });
        return new VoidApiResponse(response);
    }
    /**
     * Sets booking associated block chain wallet data.
     */
    async setBlockchainWallet(bookingId, apiBlockchainWallet) {
        await this.setBlockchainWalletRaw({ bookingId: bookingId, apiBlockchainWallet: apiBlockchainWallet });
    }
    /**
     */
    async setSpecialRequestRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling setSpecialRequest.');
        }
        if (requestParameters.apiNote === null || requestParameters.apiNote === undefined) {
            throw new RequiredError('apiNote', 'Required parameter requestParameters.apiNote was null or undefined when calling setSpecialRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/setSpecialRequest`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiNoteFromJSONTyped(requestParameters.apiNote),
        });
        return new VoidApiResponse(response);
    }
    /**
     */
    async setSpecialRequest(packageCartId, apiNote) {
        await this.setSpecialRequestRaw({ packageCartId: packageCartId, apiNote: apiNote });
    }
    /**
     * Starts new package cart
     */
    async startRaw(requestParameters) {
        if (requestParameters.packageId === null || requestParameters.packageId === undefined) {
            throw new RequiredError('packageId', 'Required parameter requestParameters.packageId was null or undefined when calling start.');
        }
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling start.');
        }
        const queryParameters = {};
        if (requestParameters.calculatePrices !== undefined) {
            queryParameters['calculatePrices'] = requestParameters.calculatePrices;
        }
        if (requestParameters.cartId !== undefined) {
            queryParameters['cartId'] = requestParameters.cartId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/start/{packageId}/{bookingId}`.replace(`{${"packageId"}}`, encodeURIComponent(String(requestParameters.packageId))).replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetPackageCartStartOptionsFromJSONTyped(requestParameters.apiGetPackageCartStartOptions),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     * Starts new package cart
     */
    async start(packageId, bookingId, calculatePrices, cartId, apiGetPackageCartStartOptions) {
        const response = await this.startRaw({ packageId: packageId, bookingId: bookingId, calculatePrices: calculatePrices, cartId: cartId, apiGetPackageCartStartOptions: apiGetPackageCartStartOptions });
        return await response.value();
    }
    /**
     * get static content
     */
    async staticContentRaw(requestParameters) {
        if (requestParameters.apiStaticContentRequest === null || requestParameters.apiStaticContentRequest === undefined) {
            throw new RequiredError('apiStaticContentRequest', 'Required parameter requestParameters.apiStaticContentRequest was null or undefined when calling staticContent.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/content/getStaticContent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiStaticContentRequestFromJSONTyped(requestParameters.apiStaticContentRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiStaticContentResponseFromJSON(jsonValue));
    }
    /**
     * get static content
     */
    async staticContent(apiStaticContentRequest) {
        const response = await this.staticContentRaw({ apiStaticContentRequest: apiStaticContentRequest });
        return await response.value();
    }
    /**
     * Submission of a Discount code
     */
    async submitDiscountRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling submitDiscount.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/submitDiscount/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiSubmitDiscountRequestFromJSONTyped(requestParameters.apiSubmitDiscountRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * Submission of a Discount code
     */
    async submitDiscount(bookingId, apiSubmitDiscountRequest) {
        const response = await this.submitDiscountRaw({ bookingId: bookingId, apiSubmitDiscountRequest: apiSubmitDiscountRequest });
        return await response.value();
    }
    /**
     * update affiliate
     */
    async updateAffiliateRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling updateAffiliate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/updateAffiliate/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUpdateAffiliateRequestFromJSONTyped(requestParameters.apiUpdateAffiliateRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * update affiliate
     */
    async updateAffiliate(bookingId, apiUpdateAffiliateRequest) {
        const response = await this.updateAffiliateRaw({ bookingId: bookingId, apiUpdateAffiliateRequest: apiUpdateAffiliateRequest });
        return await response.value();
    }
    /**
     */
    async updateBookingRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling updateBooking.');
        }
        if (requestParameters.attempt === null || requestParameters.attempt === undefined) {
            throw new RequiredError('attempt', 'Required parameter requestParameters.attempt was null or undefined when calling updateBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/update/{attempt}`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))).replace(`{${"attempt"}}`, encodeURIComponent(String(requestParameters.attempt))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     */
    async updateBooking(packageCartId, attempt) {
        const response = await this.updateBookingRaw({ packageCartId: packageCartId, attempt: attempt });
        return await response.value();
    }
    /**
     * update bookedItems specialRequests
     */
    async updateBookingItemSpecialRequestRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling updateBookingItemSpecialRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/updateBookingItemSpecialRequest/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUpdateBookingItemSpecialRequestFromJSONTyped(requestParameters.apiUpdateBookingItemSpecialRequest),
        });
        return new VoidApiResponse(response);
    }
    /**
     * update bookedItems specialRequests
     */
    async updateBookingItemSpecialRequest(bookingId, apiUpdateBookingItemSpecialRequest) {
        await this.updateBookingItemSpecialRequestRaw({ bookingId: bookingId, apiUpdateBookingItemSpecialRequest: apiUpdateBookingItemSpecialRequest });
    }
    /**
     * update bus stations
     */
    async updateBusStationsRaw(requestParameters) {
        if (requestParameters.packageCartId === null || requestParameters.packageCartId === undefined) {
            throw new RequiredError('packageCartId', 'Required parameter requestParameters.packageCartId was null or undefined when calling updateBusStations.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packageCart/{packageCartId}/busStations`.replace(`{${"packageCartId"}}`, encodeURIComponent(String(requestParameters.packageCartId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiRentalCarOfficeFromJSONTyped(requestParameters.apiRentalCarOffice),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiPackageCartFromJSON(jsonValue));
    }
    /**
     * update bus stations
     */
    async updateBusStations(packageCartId, apiRentalCarOffice) {
        const response = await this.updateBusStationsRaw({ packageCartId: packageCartId, apiRentalCarOffice: apiRentalCarOffice });
        return await response.value();
    }
    /**
     * set or update values of CaptureData
     */
    async updateCaptureDataRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling updateCaptureData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/updateCaptureData/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUpdateCaptureDataRequestFromJSONTyped(requestParameters.apiUpdateCaptureDataRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * set or update values of CaptureData
     */
    async updateCaptureData(bookingId, apiUpdateCaptureDataRequest) {
        const response = await this.updateCaptureDataRaw({ bookingId: bookingId, apiUpdateCaptureDataRequest: apiUpdateCaptureDataRequest });
        return await response.value();
    }
    /**
     * update bookingCustomProperties
     */
    async updateCustomPropertiesRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling updateCustomProperties.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/updateCustomProperties/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.apiBookingCustomProperty,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * update bookingCustomProperties
     */
    async updateCustomProperties(bookingId, apiBookingCustomProperty) {
        const response = await this.updateCustomPropertiesRaw({ bookingId: bookingId, apiBookingCustomProperty: apiBookingCustomProperty });
        return await response.value();
    }
    /**
     * update customer
     */
    async updateCustomerRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling updateCustomer.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/updateCustomer/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUpdateCustomerRequestFromJSONTyped(requestParameters.apiUpdateCustomerRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * update customer
     */
    async updateCustomer(bookingId, apiUpdateCustomerRequest) {
        const response = await this.updateCustomerRaw({ bookingId: bookingId, apiUpdateCustomerRequest: apiUpdateCustomerRequest });
        return await response.value();
    }
    /**
     */
    async updateFlightTripBookingRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling updateFlightTripBooking.');
        }
        if (requestParameters.apiGetFlightTripUpdateBookingRequest === null || requestParameters.apiGetFlightTripUpdateBookingRequest === undefined) {
            throw new RequiredError('apiGetFlightTripUpdateBookingRequest', 'Required parameter requestParameters.apiGetFlightTripUpdateBookingRequest was null or undefined when calling updateFlightTripBooking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/packages/flighttrip/update/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiGetFlightTripUpdateBookingRequestFromJSONTyped(requestParameters.apiGetFlightTripUpdateBookingRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiGetFlightTripBookingResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateFlightTripBooking(bookingId, apiGetFlightTripUpdateBookingRequest) {
        const response = await this.updateFlightTripBookingRaw({ bookingId: bookingId, apiGetFlightTripUpdateBookingRequest: apiGetFlightTripUpdateBookingRequest });
        return await response.value();
    }
    /**
     * update booking notes
     */
    async updateNotesRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling updateNotes.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/updateNotes/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUpdateNotesRequestFromJSONTyped(requestParameters.apiUpdateNotesRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * update booking notes
     */
    async updateNotes(bookingId, apiUpdateNotesRequest) {
        const response = await this.updateNotesRaw({ bookingId: bookingId, apiUpdateNotesRequest: apiUpdateNotesRequest });
        return await response.value();
    }
    /**
     * update service notes
     */
    async updateServiceNotesRaw(requestParameters) {
        if (requestParameters.attempt === null || requestParameters.attempt === undefined) {
            throw new RequiredError('attempt', 'Required parameter requestParameters.attempt was null or undefined when calling updateServiceNotes.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/service/updateNotes/{attempt}`.replace(`{${"attempt"}}`, encodeURIComponent(String(requestParameters.attempt))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUpdateServiceNotesRequestFromJSONTyped(requestParameters.apiUpdateServiceNotesRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * update service notes
     */
    async updateServiceNotes(attempt, apiUpdateServiceNotesRequest) {
        const response = await this.updateServiceNotesRaw({ attempt: attempt, apiUpdateServiceNotesRequest: apiUpdateServiceNotesRequest });
        return await response.value();
    }
    /**
     * update traveler
     */
    async updateTravelerRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling updateTraveler.');
        }
        if (requestParameters.attempt === null || requestParameters.attempt === undefined) {
            throw new RequiredError('attempt', 'Required parameter requestParameters.attempt was null or undefined when calling updateTraveler.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/traveler/{attempt}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))).replace(`{${"attempt"}}`, encodeURIComponent(String(requestParameters.attempt))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiTravelerFromJSONTyped(requestParameters.apiTraveler),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * update traveler
     */
    async updateTraveler(bookingId, attempt, apiTraveler) {
        const response = await this.updateTravelerRaw({ bookingId: bookingId, attempt: attempt, apiTraveler: apiTraveler });
        return await response.value();
    }
    /**
     * update bookedItems priceByPersonId
     */
    async updateTravelerAssignmentRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling updateTravelerAssignment.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/updateTravelerAssignment/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUpdateTravelerAssignmentRequestFromJSONTyped(requestParameters.apiUpdateTravelerAssignmentRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * update bookedItems priceByPersonId
     */
    async updateTravelerAssignment(bookingId, apiUpdateTravelerAssignmentRequest) {
        const response = await this.updateTravelerAssignmentRaw({ bookingId: bookingId, apiUpdateTravelerAssignmentRequest: apiUpdateTravelerAssignmentRequest });
        return await response.value();
    }
    /**
     * update travelers
     */
    async updateTravelersRaw(requestParameters) {
        if (requestParameters.bookingId === null || requestParameters.bookingId === undefined) {
            throw new RequiredError('bookingId', 'Required parameter requestParameters.bookingId was null or undefined when calling updateTravelers.');
        }
        if (requestParameters.attempt === null || requestParameters.attempt === undefined) {
            throw new RequiredError('attempt', 'Required parameter requestParameters.attempt was null or undefined when calling updateTravelers.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/booking/{bookingId}/travelers/{attempt}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters.bookingId))).replace(`{${"attempt"}}`, encodeURIComponent(String(requestParameters.attempt))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.apiTraveler,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiBookingFromJSON(jsonValue));
    }
    /**
     * update travelers
     */
    async updateTravelers(bookingId, attempt, apiTraveler) {
        const response = await this.updateTravelersRaw({ bookingId: bookingId, attempt: attempt, apiTraveler: apiTraveler });
        return await response.value();
    }
    /**
     * validate tax code
     */
    async validateFiscalRaw(requestParameters) {
        if (requestParameters.apiTaxCodeValidationRequest === null || requestParameters.apiTaxCodeValidationRequest === undefined) {
            throw new RequiredError('apiTaxCodeValidationRequest', 'Required parameter requestParameters.apiTaxCodeValidationRequest was null or undefined when calling validateFiscal.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/taxCode/validateFiscal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiTaxCodeValidationRequestFromJSONTyped(requestParameters.apiTaxCodeValidationRequest),
        });
        return new JSONApiResponse(response, (jsonValue) => ApiTaxCodeValidationResponseFromJSON(jsonValue));
    }
    /**
     * validate tax code
     */
    async validateFiscal(apiTaxCodeValidationRequest) {
        const response = await this.validateFiscalRaw({ apiTaxCodeValidationRequest: apiTaxCodeValidationRequest });
        return await response.value();
    }
    /**
     * Search indexed Website for destinations (title, link, matchedContentString, destinationType oneOf[\"continent\", \"city\", \"country\"])
     */
    async websiteSearchDestinationRaw(requestParameters) {
        if (requestParameters.searchQuery === null || requestParameters.searchQuery === undefined) {
            throw new RequiredError('searchQuery', 'Required parameter requestParameters.searchQuery was null or undefined when calling websiteSearchDestination.');
        }
        const queryParameters = {};
        if (requestParameters.searchQuery !== undefined) {
            queryParameters['searchQuery'] = requestParameters.searchQuery;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/websiteSearch/destination`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiWebsiteDestinationSearchResponseFromJSON(jsonValue));
    }
    /**
     * Search indexed Website for destinations (title, link, matchedContentString, destinationType oneOf[\"continent\", \"city\", \"country\"])
     */
    async websiteSearchDestination(searchQuery) {
        const response = await this.websiteSearchDestinationRaw({ searchQuery: searchQuery });
        return await response.value();
    }
    /**
     * Search indexed Website for FAQ entries (question, answer, link)
     */
    async websiteSearchFaqRaw(requestParameters) {
        if (requestParameters.searchQuery === null || requestParameters.searchQuery === undefined) {
            throw new RequiredError('searchQuery', 'Required parameter requestParameters.searchQuery was null or undefined when calling websiteSearchFaq.');
        }
        const queryParameters = {};
        if (requestParameters.searchQuery !== undefined) {
            queryParameters['searchQuery'] = requestParameters.searchQuery;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/websiteSearch/faq`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiWebsiteFaqSearchResponseFromJSON(jsonValue));
    }
    /**
     * Search indexed Website for FAQ entries (question, answer, link)
     */
    async websiteSearchFaq(searchQuery) {
        const response = await this.websiteSearchFaqRaw({ searchQuery: searchQuery });
        return await response.value();
    }
    /**
     * Search indexed Website for other pages (category, title, matchedContentString, link)
     */
    async websiteSearchOtherPagesRaw(requestParameters) {
        if (requestParameters.searchQuery === null || requestParameters.searchQuery === undefined) {
            throw new RequiredError('searchQuery', 'Required parameter requestParameters.searchQuery was null or undefined when calling websiteSearchOtherPages.');
        }
        const queryParameters = {};
        if (requestParameters.searchQuery !== undefined) {
            queryParameters['searchQuery'] = requestParameters.searchQuery;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/websiteSearch/otherPages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiWebsiteOtherPagesSearchResponseFromJSON(jsonValue));
    }
    /**
     * Search indexed Website for other pages (category, title, matchedContentString, link)
     */
    async websiteSearchOtherPages(searchQuery) {
        const response = await this.websiteSearchOtherPagesRaw({ searchQuery: searchQuery });
        return await response.value();
    }
    /**
     * Search indexed Website for products (detailed)
     */
    async websiteSearchProductRaw(requestParameters) {
        if (requestParameters.searchQuery === null || requestParameters.searchQuery === undefined) {
            throw new RequiredError('searchQuery', 'Required parameter requestParameters.searchQuery was null or undefined when calling websiteSearchProduct.');
        }
        const queryParameters = {};
        if (requestParameters.searchQuery !== undefined) {
            queryParameters['searchQuery'] = requestParameters.searchQuery;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/websiteSearch/product`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiWebsiteProductSearchResponseFromJSON(jsonValue));
    }
    /**
     * Search indexed Website for products (detailed)
     */
    async websiteSearchProduct(searchQuery) {
        const response = await this.websiteSearchProductRaw({ searchQuery: searchQuery });
        return await response.value();
    }
    /**
     * Search indexed Website for quickResults (title, link)
     */
    async websiteSearchQuickRaw(requestParameters) {
        if (requestParameters.searchQuery === null || requestParameters.searchQuery === undefined) {
            throw new RequiredError('searchQuery', 'Required parameter requestParameters.searchQuery was null or undefined when calling websiteSearchQuick.');
        }
        const queryParameters = {};
        if (requestParameters.searchQuery !== undefined) {
            queryParameters['searchQuery'] = requestParameters.searchQuery;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-IBE-Authorization"] = this.configuration.apiKey("X-IBE-Authorization"); // bearerAuth authentication
        }
        const response = await this.request({
            path: `/websiteSearch/quick`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new JSONApiResponse(response, (jsonValue) => ApiWebsiteQuickSearchResponseFromJSON(jsonValue));
    }
    /**
     * Search indexed Website for quickResults (title, link)
     */
    async websiteSearchQuick(searchQuery) {
        const response = await this.websiteSearchQuickRaw({ searchQuery: searchQuery });
        return await response.value();
    }
}

export { DefaultApi };
//# sourceMappingURL=DefaultApi.js.map
